// src/pages/contribuables/ContribuableDetails.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

import mairieLogo from "../../assets/img/nrf.png";
import mairieLogo1 from "../../assets/img/image.jpeg";
import Select from 'react-select';
import QRCode from 'qrcode';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  Card,
  Container,
  Row,
  Col,
  Form,
  Button,
  Spinner,
  Alert,
  InputGroup,
  Badge,
  Table,
  Tab,
  Tabs,
  ListGroup,
  ProgressBar,
  Dropdown,
  Modal,
  Toast,
  ToastContainer,
  Pagination
} from "react-bootstrap";
import axios from "axios";
import {
  Search,
  Person,
  Building,
  Phone,
  Envelope,
  Calendar,
  ArrowLeft,
  Eye,
  CheckCircle,
  XCircle,
  ExclamationCircle,
  CreditCard,
  Receipt,
  Cash,
  GraphUp,
  Wallet,
  ClockHistory,
  Activity,
  Tag,
  CalendarCheck,
  PhoneFill,
  EnvelopeFill,
  FileText,
  GeoAlt,
  People,
  ThreeDotsVertical,
  Filter,
  Plus,
  Trash,
  Check,
  ArrowRepeat,
  X,
  InfoCircle,
  Percent,
  HourglassSplit,
  Calculator,
  PlusCircle,
  Briefcase,
  Layers,
  BarChart,
  PieChart,
  ShieldCheck,
  Key,
  CreditCard2Front,
  Printer,
  Gear,
  Save,
  PersonFill,
  Pencil
} from "react-bootstrap-icons";
import { API_BASE_URL } from "../../constants/api_constants";

const TAXPAYERS_ENDPOINT = `${API_BASE_URL}/taxpayers`;
const LOCALITES_ENDPOINT = `${API_BASE_URL}/localites`;

// Statuts des taxes
const TAX_STATUS = {
  pending: { label: 'En attente', color: 'secondary', icon: <ClockHistory className="me-1" /> },
  paid: { label: 'Payée', color: 'success', icon: <CheckCircle className="me-1" /> },
  partial: { label: 'Partielle', color: 'warning', icon: <ExclamationCircle className="me-1" /> },
  partiel: { label: 'Partielle', color: 'warning', icon: <ExclamationCircle className="me-1" /> },
  overdue: { label: 'Impayée', color: 'danger', icon: <XCircle className="me-1" /> },
  upcoming: { label: 'À venir', color: 'info', icon: <Calendar className="me-1" /> }
};

const ECHEANCE_STATUS = {
  en_attente: { label: 'En attente', color: 'secondary', icon: <HourglassSplit className="me-1" /> },
  partial: { label: 'Partiel', color: 'warning', icon: <Percent className="me-1" /> },
  partiel: { label: 'Partiel', color: 'warning', icon: <Percent className="me-1" /> },
  completed: { label: 'Soldée', color: 'success', icon: <CheckCircle className="me-1" /> }
};

// ==================== CACHE LOCALITÉS (sessionStorage) ====================
const LOCALITES_CACHE_KEY = 'synctaxe_localites_cache';
const LOCALITES_CACHE_TTL = 24 * 60 * 60 * 1000; // 24h

const getCachedLocalites = () => {
  try {
    const raw = sessionStorage.getItem(LOCALITES_CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (Date.now() - parsed.timestamp > LOCALITES_CACHE_TTL) return null;
    return parsed.data;
  } catch {
    return null;
  }
};

const setCachedLocalites = (data) => {
  try {
    sessionStorage.setItem(LOCALITES_CACHE_KEY, JSON.stringify({
      data,
      timestamp: Date.now()
    }));
  } catch {}
};

export default function ContribuableDetails() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [taxActivityFilter, setTaxActivityFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  const [loadingSubAccounts, setLoadingSubAccounts] = useState(false);
  const [contribuable, setContribuable] = useState(null);
  const [error, setError] = useState(null);
  const [echeances, setEcheances] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [assignedTaxes, setAssignedTaxes] = useState([]);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [activeTab, setActiveTab] = useState("overview");
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [sortConfig, setSortConfig] = useState({ key: 'type', direction: 'ascending' });
  const [toasts, setToasts] = useState([]);
  const [filterLoading, setFilterLoading] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);
  const [activityStatsPage, setActivityStatsPage] = useState(1);
  const [activityStatsPerPage, setActivityStatsPerPage] = useState(3);

  // Stats globales (retournées par l'API unifiée)
  const [globalStats, setGlobalStats] = useState({
    total_echeances: 0,
    total_initial: 0,
    total_paye: 0,
    total_restant: 0,
    taux_recouvrement: 0,
    echeances_completed: 0,
    echeances_partial: 0,
    echeances_en_attente: 0,
    montant_completed: 0,
    montant_partial_paid: 0,
    montant_en_attente_restant: 0,
  });

  // Filtres et pagination échéances
  const [echeanceSearchTerm, setEcheanceSearchTerm] = useState("");
  const [loadingModalOpen, setLoadingModalOpen] = useState(false);
  const [regeneratingEcheances, setRegeneratingEcheances] = useState(false);
  const [showRegenerateConfirm, setShowRegenerateConfirm] = useState(false);
  const [regenerateType, setRegenerateType] = useState('missing');
  const [showEcheanceStatusModal, setShowEcheanceStatusModal] = useState(false);
  const [echeanceStatusData, setEcheanceStatusData] = useState(null);
  const [removeTaxReason, setRemoveTaxReason] = useState("");
  const [echeanceCurrentPage, setEcheanceCurrentPage] = useState(1);
  const [echeanceItemsPerPage, setEcheanceItemsPerPage] = useState(10);
  const [echeanceActivityFilter, setEcheanceActivityFilter] = useState("all");
  const [echeanceLoading, setEcheanceLoading] = useState(false);
  const [echeanceTotalPages, setEcheanceTotalPages] = useState(1);
  const [echeanceTotalItems, setEcheanceTotalItems] = useState(0);

  // ✅ Pagination SERVEUR des échéances (charger plus)
  const [serverEcheancesPage, setServerEcheancesPage] = useState(1);
  const [serverEcheancesLastPage, setServerEcheancesLastPage] = useState(1);
  const [loadingMoreEcheances, setLoadingMoreEcheances] = useState(false);

  // États pour les taxes de l'activité sélectionnée
  const [selectedActivityTaxes, setSelectedActivityTaxes] = useState([]);
  const [loadingActivityTaxes, setLoadingActivityTaxes] = useState(false);

  // États pour les modals
  const [showEditModal, setShowEditModal] = useState(false);
  const [showAssignTaxModal, setShowAssignTaxModal] = useState(false);
  const [showRemoveTaxModal, setShowRemoveTaxModal] = useState(false);
  const [editForm, setEditForm] = useState({});
  const [availableTaxes, setAvailableTaxes] = useState([]);
  const [selectedTaxes, setSelectedTaxes] = useState([]);
  const [loadingTaxes, setLoadingTaxes] = useState(false);
  const [assigningTaxes, setAssigningTaxes] = useState(false);
  const [taxToRemove, setTaxToRemove] = useState(null);
  const [removingTax, setRemovingTax] = useState(false);
  const [updatingContact, setUpdatingContact] = useState(false);
  const [syncLoading, setSyncLoading] = useState(false);

  // États pour le multi-activité
  const [subAccounts, setSubAccounts] = useState([]);
  const [selectedActivityFilter, setSelectedActivityFilter] = useState("all");
  const [showAddActivityModal, setShowAddActivityModal] = useState(false);
  const [availableActivities, setAvailableActivities] = useState([]);
  const [loadingActivities, setLoadingActivities] = useState(false);
  const [selectedActivityForAdd, setSelectedActivityForAdd] = useState(null);
  const [addingActivity, setAddingActivity] = useState(false);
  const [activityIdNat, setActivityIdNat] = useState("");
  const [activityRccm, setActivityRccm] = useState("");
  const [activityNif, setActivityNif] = useState("");
  const [validationErrors, setValidationErrors] = useState({});

  const defaultCurrency = sessionStorage.getItem("default_currency") || 'XOF';

  // États pour l'activité journalière
  const [activityData, setActivityData] = useState([]);
  const [loadingActivity, setLoadingActivity] = useState(false);
  const [activityFilter, setActivityFilter] = useState("all");
  const [activityPage, setActivityPage] = useState(1);

  // États pour l'impression Bluetooth
  const [showDeviceModal, setShowDeviceModal] = useState(false);
  const [availableDevices, setAvailableDevices] = useState([]);
  const [scanningDevices, setScanningDevices] = useState(false);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [selectedEcheance, setSelectedEcheance] = useState(null);
  const [printingBluetooth, setPrintingBluetooth] = useState(false);
  const [bluetoothStatus, setBluetoothStatus] = useState('');

  // États pour les localités
  const [allLocalites, setAllLocalites] = useState([]);
  const [localiteInfo, setLocaliteInfo] = useState(null);
  const [loadingLocalite, setLoadingLocalite] = useState(false);

  // États pour la modification des taxes et échéances
  const [showEditTaxModal, setShowEditTaxModal] = useState(false);
  const [selectedTax, setSelectedTax] = useState(null);
  const [editTaxAmount, setEditTaxAmount] = useState("");
  const [editTaxFrequency, setEditTaxFrequency] = useState("");
  const [editTaxStartDate, setEditTaxStartDate] = useState("");
  const [savingTax, setSavingTax] = useState(false);

  const [showEditEcheanceModal, setShowEditEcheanceModal] = useState(false);
  const [editEcheanceAmount, setEditEcheanceAmount] = useState("");
  const [editEcheanceDate, setEditEcheanceDate] = useState("");
  const [savingEcheance, setSavingEcheance] = useState(false);

  // Statistiques
  const [echeanceStats, setEcheanceStats] = useState({
    en_attente: { count: 0, total: 0 },
    partial: { count: 0, total: 0 },
    completed: { count: 0, total: 0 }
  });

  // Mapping des activités
  const [activityMapping, setActivityMapping] = useState({});

  const [subAccountsPage, setSubAccountsPage] = useState(1);
  const [subAccountsPerPage, setSubAccountsPerPage] = useState(5);

  // États pour la modification d'activité
  const [showModifyActivityModal, setShowModifyActivityModal] = useState(false);
  const [selectedActivityToModify, setSelectedActivityToModify] = useState(null);
  const [selectedNewActivityForModify, setSelectedNewActivityForModify] = useState(null);
  const [modifyingActivity, setModifyingActivity] = useState(false);
  const [modifyActivityVerification, setModifyActivityVerification] = useState(null);
  const [regenerateEcheancesAfterModify, setRegenerateEcheancesAfterModify] = useState(true);
  const [modifyActivityStartDate, setModifyActivityStartDate] = useState(new Date().toISOString().split('T')[0]);
  const [availableActivitiesForModify, setAvailableActivitiesForModify] = useState([]);
  const [loadingModifyActivities, setLoadingModifyActivities] = useState(false);

  // États pour l'ajout d'activité avec localisation
  const [activityAdresse, setActivityAdresse] = useState("");
  const [activityQuartierId, setActivityQuartierId] = useState("");
  const [activityQuartierInfo, setActivityQuartierInfo] = useState(null);
  const [activityCodePostal, setActivityCodePostal] = useState("");
  const [loadingActivityQuartiers, setLoadingActivityQuartiers] = useState(false);
  const [quartierOptionsForActivity, setQuartierOptionsForActivity] = useState([]);
  const [allLocalitesForActivity, setAllLocalitesForActivity] = useState([]);




  // Dans les états
// Remplacez l'état précédent par celui-ci
const [logoDimensions, setLogoDimensions] = useState({ width: 0, height: 0, dataUrl: null });

useEffect(() => {
  const loadLogo = () => {
    const img = new Image();
    img.src = mairieLogo;
    img.onload = () => {
      // Calcul du ratio pour une hauteur fixe de 25mm
      const targetHeight = 22; 
      const targetWidth = (img.width / img.height) * targetHeight;
      
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      
      setLogoDimensions({
        width: targetWidth,
        height: targetHeight,
        dataUrl: canvas.toDataURL('image/png')
      });
    };
  };
  loadLogo();
}, []);
  // ==================== FONCTIONS UTILITAIRES ====================

  const getPaginatedSubAccounts = () => {
    const startIndex = (subAccountsPage - 1) * subAccountsPerPage;
    const paginated = subAccounts.slice(startIndex, startIndex + subAccountsPerPage);
    const totalPages = Math.ceil(subAccounts.length / subAccountsPerPage);
    return { paginated, totalPages, totalItems: subAccounts.length };
  };

  const getPaginatedActivityStats = () => {
    const statsArray = Object.values(activityStats);
    const startIndex = (activityStatsPage - 1) * activityStatsPerPage;
    const paginated = statsArray.slice(startIndex, startIndex + activityStatsPerPage);
    const totalPages = Math.ceil(statsArray.length / activityStatsPerPage);
    return { paginated, totalPages, totalItems: statsArray.length };
  };

  const showToast = (message, type = 'success', title = '') => {
    const id = Date.now();
    setToasts(prev => [...prev, { id, message, type, title: title || (type === 'success' ? 'Succès' : type === 'danger' ? 'Erreur' : 'Information') }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 5000);
  };

  const getAuthToken = () => sessionStorage.getItem("authToken");
  const getHeaders = () => {
    const token = getAuthToken();
    const headers = { "Content-Type": "application/json", "Accept": "application/json" };
    if (token) headers["Authorization"] = `Bearer ${token}`;
    return headers;
  };

  const formatCurrency = (amount) => {
    const numAmount = parseFloat(amount) || 0;
    return numAmount.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' ' + defaultCurrency;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Non spécifié";
    return new Date(dateString).toLocaleDateString('fr-FR');
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return "Non spécifié";
    return new Date(dateString).toLocaleDateString('fr-FR', {
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  };

  const formatRelativeTime = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      const now = new Date();
      const diffMs = now - date;
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMs / 3600000);
      const diffDays = Math.floor(diffMs / 86400000);

      if (diffMins < 1) return "À l'instant";
      if (diffMins < 60) return `Il y a ${diffMins} minute${diffMins > 1 ? 's' : ''}`;
      if (diffHours < 24) return `Il y a ${diffHours} heure${diffHours > 1 ? 's' : ''}`;
      if (diffDays < 7) return `Il y a ${diffDays} jour${diffDays > 1 ? 's' : ''}`;
      return formatDate(dateString);
    } catch {
      return "";
    }
  };

  const getEcheanceStatusBadge = (statut) => {
    const config = ECHEANCE_STATUS[statut] || ECHEANCE_STATUS.en_attente;
    return <Badge bg={config.color} className="px-2 py-1 d-flex align-items-center gap-1" style={{ fontSize: '0.7rem' }}>{config.icon}{config.label}</Badge>;
  };

  const getTaxStatusBadge = (tax) => {
    if (tax.realStatus === 'paid') {
      return <Badge bg="success" className="d-flex align-items-center gap-1 px-2 py-1"><CheckCircle size={12} /> Payée</Badge>;
    }
    if (tax.realStatus === 'partial') {
      return <Badge bg="warning" className="d-flex align-items-center gap-1 px-2 py-1"><Percent size={12} /> Partielle</Badge>;
    }
    if (tax.realStatus === 'overdue') {
      return <Badge bg="danger" className="d-flex align-items-center gap-1 px-2 py-1"><XCircle size={12} /> Impayée</Badge>;
    }
    return <Badge bg="secondary" className="d-flex align-items-center gap-1 px-2 py-1"><ClockHistory size={12} /> En attente</Badge>;
  };

  const getActivityName = (activityId) => {
    if (!activityId) return 'Non spécifiée';
    if (Object.keys(activityMapping).length === 0) return 'Chargement...';
    return activityMapping[activityId] || activityId;
  };

  const normalizeFrequency = (freq) => {
    if (!freq) return 'monthly';
    const frequencyMap = {
      'semi_annual': 'semiannual',
      'semiannual': 'semiannual',
      'monthly': 'monthly',
      'quarterly': 'quarterly',
      'annual': 'annual',
      'daily': 'daily',
      'one_off': 'one_off',
      'mensuelle': 'monthly',
      'trimestrielle': 'quarterly',
      'annuelle': 'annual',
      'journalière': 'daily',
      'unique': 'one_off'
    };
    return frequencyMap[freq.toLowerCase()] || 'monthly';
  };

  // ==================== LOCALITÉS ====================

  const fetchActivityLocalites = async () => {
    try {
      setLoadingActivityQuartiers(true);

      let localites = getCachedLocalites();
      if (!localites) {
        const response = await axios.get(LOCALITES_ENDPOINT, { headers: getHeaders() });
        if (Array.isArray(response.data)) localites = response.data;
        else if (response.data?.data && Array.isArray(response.data.data)) localites = response.data.data;
        else localites = [];
        setCachedLocalites(localites);
      }

      setAllLocalitesForActivity(localites);

      const def_type_localite = Number(sessionStorage.getItem("def_type_localite") || 1002);
      const quartiersList = localites.filter(l => l.type_code === def_type_localite);

      const sortedQuartiers = [...quartiersList].sort((a, b) => (a.nom || '').localeCompare(b.nom || ''));

      const options = sortedQuartiers.map(q => {
        const parent = localites.find(a => a.localite_id === q.parent_id);
        let label = q.nom;
        if (parent) label += ` - ${parent.nom}`;
        return { value: q.localite_id, label, original: q, parent };
      });

      setQuartierOptionsForActivity(options);
    } catch (error) {
      console.error("❌ Erreur chargement localités:", error);
    } finally {
      setLoadingActivityQuartiers(false);
    }
  };

  const handleActivityQuartierChange = (selectedOption) => {
    setActivityQuartierInfo(selectedOption);
    setActivityQuartierId(selectedOption ? selectedOption.value : "");
  };

  const getLocaliteTypeName = (typeCode) => {
    const typeLabels = {
      1000: "Commune", 1001: "Ville", 1002: "Quartier",
      1003: "Arrondissement", 1004: "Département", 1005: "Province"
    };
    return typeLabels[typeCode] || "Localité";
  };

  const getParentChain = (localitesList, localiteId, chain = []) => {
    if (!localiteId) return chain;
    const current = localitesList.find(l => l.localite_id === localiteId);
    if (!current) return chain;
    chain.unshift(current);
    if (current.parent_id) return getParentChain(localitesList, current.parent_id, chain);
    return chain;
  };

  const extractLocationInfoFromChain = (chain) => {
    let province = null, departement = null, ville = null, commune = null, arrondissement = null, quartier = null, pays = null;
    chain.forEach(loc => {
      if (loc.pays_code && !pays) pays = loc.pays_code === "CD" ? "RDC" : loc.pays_code;
      switch (loc.type_code) {
        case 1005: if (!province) province = loc.nom; break;
        case 1004: if (!departement) departement = loc.nom; break;
        case 1001: if (!ville) ville = loc.nom; break;
        case 1000: if (!commune) commune = loc.nom; break;
        case 1003: if (!arrondissement) arrondissement = loc.nom; break;
        case 1002: if (!quartier) quartier = loc.nom; break;
        default: break;
      }
    });
    if (commune && !ville) ville = commune;
    const adresseParts = [];
    if (quartier) adresseParts.push(quartier);
    if (arrondissement) adresseParts.push(arrondissement);
    if (commune) adresseParts.push(commune);
    if (ville) adresseParts.push(ville);
    if (departement) adresseParts.push(departement);
    if (province) adresseParts.push(province);
    return {
      province, departement, ville, commune, arrondissement, quartier,
      pays: pays || "RDC",
      adresseComplete: adresseParts.join(', '),
      chaineComplete: chain
    };
  };

  // ==================== AJOUT ACTIVITÉ ====================

  const handleAddActivityWithLocation = async () => {
    if (!contribuable) { showToast("Aucun contribuable sélectionné", "warning"); return; }
    if (!selectedActivityForAdd) { showToast("Veuillez sélectionner une activité", "warning"); return; }

    setAddingActivity(true);
    setValidationErrors({});
    const randomNum = Math.floor(Math.random() * 9999) + 1;
    try {
      const submitData = {
        nom_entite: `${contribuable.nom_contribuable} - ${selectedActivityForAdd.label.split(' - ')[0]}`,
        admin_full_name: contribuable.admin_full_name || contribuable.nom_contribuable || "",
        first_name: contribuable.first_name || "",
        forme_juridique: contribuable.forme_juridique ? Number(contribuable.forme_juridique) : null,
        activite_contribuable: selectedActivityForAdd.value,
        telephone: `${contribuable.telephone}-${randomNum}`,
        email: contribuable.email || "",
        admin_email: contribuable.admin_email || contribuable.email || "",
        adresse: activityAdresse.trim() || contribuable.adresse || "",
        localite_id: activityQuartierId || contribuable.localite_id || null,
        code_postal: activityCodePostal || contribuable.code_postal || "",
        id_nat: activityIdNat.trim() || null,
        rccm: activityRccm.trim() || null,
        nif: activityNif.trim() || null,
        main_account_id: contribuable.contribuable_id.toString(),
        is_active: true,
        role_id: 1012
      };

      const response = await axios.post(TAXPAYERS_ENDPOINT, submitData, { headers: getHeaders() });

      if (response.data && response.data.entite) {
        showToast(`Activité ajoutée avec succès`, "success");
        setSelectedActivityForAdd(null);
        setSelectedActivityTaxes([]);
        setActivityIdNat("");
        setActivityRccm("");
        setActivityNif("");
        setActivityAdresse("");
        setActivityQuartierId("");
        setActivityQuartierInfo(null);
        setActivityCodePostal("");
        setShowAddActivityModal(false);

        setTimeout(() => fetchContribuableData(), 300);
      }
    } catch (error) {
      console.error("Erreur ajout activité:", error);
      if (error.response?.status === 422 && error.response?.data?.errors) {
        setValidationErrors(error.response.data.errors);
        showToast("Veuillez corriger les erreurs de validation", "warning");
      } else {
        showToast(error.response?.data?.message || "Erreur lors de l'ajout", "danger");
      }
    } finally {
      setAddingActivity(false);
    }
  };

  // ==================== RÉGÉNÉRATION ====================

  const regenerateMissingEcheances = async () => {
    setRegeneratingEcheances(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/taxpayers/${contribuable.contribuable_id}/regenerate-missing-echeances`,
        {},
        { headers: getHeaders() }
      );
      if (response.data.success) {
        showToast(response.data.message, 'success');
        setTimeout(() => fetchContribuableData(), 500);
      }
    } catch (error) {
      showToast(error.response?.data?.message || "Erreur lors de la régénération", 'danger');
    } finally {
      setRegeneratingEcheances(false);
      setShowRegenerateConfirm(false);
    }
  };

  const regenerateAllEcheances = async () => {
    setRegeneratingEcheances(true);
    try {
      const response = await axios.post(
        `${API_BASE_URL}/taxpayers/${contribuable.contribuable_id}/regenerate-all-echeances`,
        {},
        { headers: getHeaders() }
      );
      if (response.data.success) {
        showToast(response.data.message, 'success');
        setTimeout(() => fetchContribuableData(), 500);
      }
    } catch (error) {
      showToast(error.response?.data?.message || "Erreur lors de la régénération", 'danger');
    } finally {
      setRegeneratingEcheances(false);
      setShowRegenerateConfirm(false);
    }
  };

  const checkEcheancesStatus = async () => {
    setRegeneratingEcheances(true);
    try {
      const response = await axios.get(
        `${API_BASE_URL}/taxpayers/${contribuable.contribuable_id}/check-echeances-status`,
        { headers: getHeaders() }
      );
      if (response.data.success) {
        setEcheanceStatusData(response.data.data);
        setShowEcheanceStatusModal(true);
      }
    } catch (error) {
      showToast(error.response?.data?.message || "Erreur lors de la vérification", 'danger');
    } finally {
      setRegeneratingEcheances(false);
    }
  };

  // ==================== FETCH TRANSACTIONS ====================

  const fetchTransactions = async (contribuableId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/payments`, {
        headers: getHeaders(),
        params: { usager_id: contribuableId }
      });
      if (response.data?.code === 200 && Array.isArray(response.data.paiements)) {
        setTransactions(response.data.paiements.filter(p => p.usager_id?.toString() === contribuableId.toString()));
      } else {
        setTransactions([]);
      }
    } catch {
      setTransactions([]);
    }
  };

  // ==================== ACTIVITÉS DISPONIBLES (lazy) ====================

  const fetchAvailableActivitiesLazy = async () => {
    if (availableActivities.length > 0) return;

    setLoadingActivities(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/activites?has_tax=yes`, { headers: getHeaders() });
      let activities = [];
      if (Array.isArray(response.data)) activities = response.data;
      else if (response.data?.data && Array.isArray(response.data.data)) activities = response.data.data;

      const assignedIds = new Set();
      if (contribuable?.activite_contribuable) assignedIds.add(String(contribuable.activite_contribuable));
      subAccounts.forEach(sub => {
        if (sub.activite_contribuable) assignedIds.add(String(sub.activite_contribuable));
      });
      assignedTaxes.forEach(tax => {
        if (tax.activite_contribuable) assignedIds.add(String(tax.activite_contribuable));
      });

      const filtered = activities.filter(act => {
        const activityId = String(act.id_export || act.code_category || act.id);
        return !assignedIds.has(activityId);
      });

      const formatted = filtered.map(act => ({
        value: act.id_export || act.code_category || act.id,
        label: `${act.name}${act.cat_name ? ` - ${act.cat_name}` : ''}${act.description ? ` (${act.description})` : ''}`,
        original: act
      }));

      setAvailableActivities(formatted);
    } catch (error) {
      console.error("Erreur chargement activités:", error);
      setAvailableActivities([]);
    } finally {
      setLoadingActivities(false);
    }
  };

  const fetchActivityTaxesForAdd = async (activityId) => {
    if (!activityId) { setSelectedActivityTaxes([]); return; }
    try {
      setLoadingActivityTaxes(true);
      const response = await axios.get(`${API_BASE_URL}/taxes-activity/${activityId}`, { headers: getHeaders() });
      let taxesData = [];
      if (response.data?.data && Array.isArray(response.data.data)) taxesData = response.data.data;
      else if (Array.isArray(response.data)) taxesData = response.data;
      else if (response.data?.taxes && Array.isArray(response.data.taxes)) taxesData = response.data.taxes;
      else if (response.data?.results && Array.isArray(response.data.results)) taxesData = response.data.results;
      setSelectedActivityTaxes(taxesData);
    } catch (error) {
      console.error("❌ Erreur chargement taxes:", error);
      setSelectedActivityTaxes([]);
    } finally {
      setLoadingActivityTaxes(false);
    }
  };

  const fetchAvailableTaxes = async () => {
    if (!contribuable) return;
    try {
      setLoadingTaxes(true);
      let assignedTaxIds = [];
      try {
        const assignedResponse = await axios.get(`${API_BASE_URL}/taxpayers/${contribuable.contribuable_id}/taxes`, { headers: getHeaders() });
        if (Array.isArray(assignedResponse.data)) assignedTaxIds = assignedResponse.data.map(t => t.taxe_id);
        else if (assignedResponse.data?.data && Array.isArray(assignedResponse.data.data)) assignedTaxIds = assignedResponse.data.data.map(t => t.taxe_id);
      } catch {}

      const response = await axios.get(`${API_BASE_URL}/taxes`, { headers: getHeaders() });
      let allTaxes = [];
      if (response.data?.data && Array.isArray(response.data.data)) allTaxes = response.data.data;
      else if (Array.isArray(response.data)) allTaxes = response.data;

      const unassignedTaxes = allTaxes.filter(tax => !assignedTaxIds.includes(tax.taxe_id));
      const formattedTaxes = unassignedTaxes.map(tax => ({
        ...tax,
        frequence: tax.frequence || 'monthly',
        titre: tax.titre || 'Taxe sans titre'
      }));
      setAvailableTaxes(formattedTaxes);
    } catch (error) {
      console.error("Erreur dans fetchAvailableTaxes:", error);
      setAvailableTaxes([]);
    } finally {
      setLoadingTaxes(false);
    }
  };

  // ==================== ⭐ FETCH PRINCIPAL UNIFIÉ ⭐ ====================

  const fetchContribuableData = async () => {
    if (!id) {
      setError("ID du contribuable non fourni");
      setLoading(false);
      return;
    }

    setLoading(true);
    setLoadingDetails(true);
    setError(null);
    setDataLoaded(false);

    try {
      const response = await axios.get(
        `${TAXPAYERS_ENDPOINT}/${id}/details-web?echeances_page=1&echeances_per_page=50&taxes_page=1&taxes_per_page=100`,
        { headers: getHeaders() }
      );

      const data = response.data;

      if (!data.contribuable) {
        showToast("Aucun contribuable trouvé avec cet ID", "danger");
        setError("Aucun contribuable trouvé avec cet ID");
        return;
      }

      // 1. Contribuable
      const c = data.contribuable;
      setContribuable(c);
      setEditForm({
        nom_contribuable: c.nom_contribuable,
        telephone: c.telephone,
        email: c.email || "",
        adresse: c.adresse || "",
        activite_contribuable: c.activite_contribuable || ""
      });

      // 2. Sous-comptes
      const subs = data.sous_comptes || [];
      setSubAccounts(subs.map(s => ({
        ...s,
        activite_nom: s.activite_nom || s.nom_contribuable || 'Sous-activité'
      })));

      // 3. Mapping activités
      const mapping = {};
      if (data.activite_principale) {
        const apId = String(c.activite_contribuable);
        mapping[apId] = data.activite_principale.name ||
                        data.activite_principale.cat_name ||
                        `Activité ${apId}`;
      }
      (data.activites_disponibles || []).forEach(a => {
        mapping[a.value] = a.label;
      });
      subs.forEach(s => {
        if (s.activite_contribuable && s.activite_nom) {
          mapping[s.activite_contribuable] = s.activite_nom;
        }
      });
      setActivityMapping(mapping);

      // 4. Localités
      const locs = data.localites || [];
      if (locs.length > 0) {
        setAllLocalites(locs);
        setCachedLocalites(locs);
      }

      // 5. Localité du contribuable
      if (locs.length > 0 && c.localite_id) {
        const chain = getParentChain(locs, c.localite_id, []);
        if (chain.length > 0) {
          setLocaliteInfo(extractLocationInfoFromChain(chain));
        } else {
          setLocaliteInfo({
            adresseComplete: c.adresse || "Adresse non spécifiée",
            pays: "RDC"
          });
        }
      } else {
        setLocaliteInfo({
          adresseComplete: c.adresse || "Adresse non spécifiée",
          pays: "RDC"
        });
      }

      // 6. ✅ Stats globales (avec répartition par statut)
      const statsFromApi = data.stats || {};
      setGlobalStats({
        total_echeances: parseInt(statsFromApi.total_echeances || 0),
        total_initial: parseFloat(statsFromApi.total_initial || 0),
        total_paye: parseFloat(statsFromApi.total_paye || 0),
        total_restant: parseFloat(statsFromApi.total_restant || 0),
        taux_recouvrement: parseFloat(statsFromApi.taux_recouvrement || 0),
        // ✅ Répartition par statut (calculée côté serveur sur TOUTES les échéances)
        echeances_completed: parseInt(statsFromApi.echeances_completed || 0),
        echeances_partial: parseInt(statsFromApi.echeances_partial || 0),
        echeances_en_attente: parseInt(statsFromApi.echeances_en_attente || 0),
        montant_completed: parseFloat(statsFromApi.montant_completed || 0),
        montant_partial_paid: parseFloat(statsFromApi.montant_partial_paid || 0),
        montant_en_attente_restant: parseFloat(statsFromApi.montant_en_attente_restant || 0),
      });

      // ✅ Répartition par statut depuis l'API (PAS de calcul local)
      setEcheanceStats({
        en_attente: {
          count: parseInt(statsFromApi.echeances_en_attente || 0),
          total: parseFloat(statsFromApi.montant_en_attente_restant || 0),
        },
        partial: {
          count: parseInt(statsFromApi.echeances_partial || 0),
          total: parseFloat(statsFromApi.montant_partial_paid || 0),
        },
        completed: {
          count: parseInt(statsFromApi.echeances_completed || 0),
          total: parseFloat(statsFromApi.montant_completed || 0),
        },
      });

      // 7. Échéances (pagination serveur)
      const echData = data.echeances?.data || [];
      const mainActivityName = data.activite_principale?.name || 'Activité principale';
      const formattedEcheances = echData.map(e => {
        const usagerId = parseInt(e.usager_id);
        const isMain = usagerId === parseInt(c.contribuable_id);
        const sub = subs.find(s => parseInt(s.contribuable_id) === usagerId);
        return {
          ...e,
          statut: e.statut || 'en_attente',
          _activityId: usagerId,
          _activityName: isMain ? mainActivityName : (sub?.activite_nom || 'Sous-activité')
        };
      });
      setEcheances(formattedEcheances);

      // ✅ Pagination serveur
      const echeancesPagination = data.echeances?.pagination || {};
      setEcheanceTotalItems(parseInt(echeancesPagination.total || 0));
      setEcheanceTotalPages(parseInt(echeancesPagination.last_page || 1));
      setServerEcheancesPage(parseInt(echeancesPagination.current_page || 1));
      setServerEcheancesLastPage(parseInt(echeancesPagination.last_page || 1));

      // 8. Taxes assignées
      const taxesRaw = data.taxes?.data || [];
      const taxesWithDetails = taxesRaw.map(t => {
        const total = parseFloat(t.montant_total || 0);
        const paye = parseFloat(t.montant_paye || 0);
        const reste = Math.max(0, total - paye);
        const usagerId = parseInt(t.usager_id);
        const isMain = usagerId === parseInt(c.contribuable_id);
        const sub = subs.find(s => parseInt(s.contribuable_id) === usagerId);

        let realStatus = 'pending';
        if (total > 0 && paye >= total) realStatus = 'paid';
        else if (paye > 0 && paye < total) realStatus = 'partial';

        const echeancesTaxe = formattedEcheances.filter(e =>
          String(e.taxe_id) === String(t.taxe_id) && e._activityId === usagerId
        );

        if (realStatus === 'pending' &&
            echeancesTaxe.some(e => e.date_echeance && new Date(e.date_echeance) < new Date() && e.statut !== 'completed')) {
          realStatus = 'overdue';
        }

        const customAmount = parseFloat(t.montant_personnalise || 0);
        const defaultAmount = parseFloat(t.default_amount || 0);
        const echeancesCount = parseInt(t.echeances_count || 0);
        const montantParEcheance = customAmount > 0
          ? customAmount
          : (echeancesCount > 0 ? total / echeancesCount : defaultAmount);

        let annee = new Date().getFullYear().toString();
        if (echeancesTaxe.length > 0 && echeancesTaxe[0].date_echeance) {
          annee = new Date(echeancesTaxe[0].date_echeance).getFullYear().toString();
        }

        return {
          id: t.id,
          taxe_id: t.taxe_id,
          type: t.nom_taxe || 'Taxe',
          description: t.description || '',
          montant_par_echeance: montantParEcheance,
          montant: total,
          montantPaye: paye,
          montantRestant: reste,
          pourcentagePaiement: total > 0 ? (paye / total) * 100 : 0,
          realStatus,
          couleur: realStatus === 'paid' ? 'success'
                 : realStatus === 'partial' ? 'warning'
                 : realStatus === 'overdue' ? 'danger'
                 : 'secondary',
          annee,
          echeancesCount,
          activityId: usagerId,
          activityName: isMain ? mainActivityName : (sub?.activite_nom || 'Sous-activité'),
          isMainAccount: isMain,
          activite_contribuable: t.activite_contribuable,
          frequence: t.frequence || 'monthly'
        };
      });
      setAssignedTaxes(taxesWithDetails);

      // 9. Activités disponibles
      const activitesDispo = (data.activites_disponibles || []).map(a => ({
        value: a.value,
        label: a.label,
        original: a
      }));
      setAvailableActivities(activitesDispo);

      // 10. Transactions (non bloquant)
      fetchTransactions(c.contribuable_id).catch(err =>
        console.error("Erreur transactions:", err)
      );

      setDataLoaded(true);
    } catch (error) {
      console.error("Erreur chargement contribuable:", error);
      if (error.response?.status === 404) {
        showToast("Aucun contribuable trouvé avec cet ID", "danger");
        setError("Aucun contribuable trouvé avec cet ID");
      } else {
        showToast(`Erreur: ${error.response?.data?.message || error.message}`, "danger");
        setError(`Erreur: ${error.response?.data?.message || error.message}`);
      }
    } finally {
      setLoadingDetails(false);
      setLoading(false);
    }
  };

  // ==================== ✅ CHARGER PLUS D'ÉCHÉANCES ====================

  const loadMoreEcheances = async () => {
    if (loadingMoreEcheances) return;
    if (serverEcheancesPage >= serverEcheancesLastPage) return;

    setLoadingMoreEcheances(true);
    try {
      const nextPage = serverEcheancesPage + 1;
      const response = await axios.get(
        `${TAXPAYERS_ENDPOINT}/${id}/details-web?echeances_page=${nextPage}&echeances_per_page=50&taxes_page=1&taxes_per_page=1`,
        { headers: getHeaders() }
      );

      const data = response.data;
      const newEcheancesRaw = data.echeances?.data || [];
      const pagination = data.echeances?.pagination || {};

      const c = contribuable;
      const subs = subAccounts;
      const mainActivityName = activityMapping[c?.activite_contribuable] || 'Activité principale';

      const formattedNewEcheances = newEcheancesRaw.map(e => {
        const usagerId = parseInt(e.usager_id);
        const isMain = usagerId === parseInt(c.contribuable_id);
        const sub = subs.find(s => parseInt(s.contribuable_id) === usagerId);
        return {
          ...e,
          statut: e.statut || 'en_attente',
          _activityId: usagerId,
          _activityName: isMain ? mainActivityName : (sub?.activite_nom || 'Sous-activité')
        };
      });

      setEcheances(prev => {
        const existingIds = new Set(prev.map(e => e.id));
        const filtered = formattedNewEcheances.filter(e => !existingIds.has(e.id));
        return [...prev, ...filtered];
      });

      setServerEcheancesPage(parseInt(pagination.current_page || nextPage));
      setServerEcheancesLastPage(parseInt(pagination.last_page || 1));
    } catch (error) {
      console.error("❌ Erreur chargement échéances supplémentaires:", error);
      showToast("Erreur lors du chargement des échéances", "danger");
    } finally {
      setLoadingMoreEcheances(false);
    }
  };

  // ==================== ACTIONS ====================

  const handleAssignTaxes = async () => {
    if (!contribuable || selectedTaxes.length === 0) {
      showToast("Veuillez sélectionner au moins une taxe", "warning");
      return;
    }
    setAssigningTaxes(true);
    try {
      let successCount = 0, errorCount = 0;
      for (const taxId of selectedTaxes) {
        const taxDetails = availableTaxes.find(t => t.taxe_id === taxId);
        const taxIdString = String(taxId);
        await axios.post(
          `${API_BASE_URL}/taxpayers/${contribuable.contribuable_id}/add-taxe`,
          { taxe_id: taxIdString, usager_id: parseInt(contribuable.contribuable_id) },
          { headers: getHeaders() }
        );
        if (taxDetails) {
          const normalizedFreq = normalizeFrequency(taxDetails.frequence);
          const generated = await generateEcheances(contribuable.contribuable_id, taxIdString, normalizedFreq, new Date().toISOString().split('T')[0]);
          if (generated) successCount++; else errorCount++;
        } else {
          const generated = await generateEcheances(contribuable.contribuable_id, taxIdString, 'monthly', new Date().toISOString().split('T')[0]);
          if (generated) successCount++; else errorCount++;
        }
      }
      setSelectedTaxes([]);
      await fetchAvailableTaxes();
      await fetchContribuableData();
      setShowAssignTaxModal(false);
      if (successCount > 0) showToast(`${successCount} taxe(s) affectée(s) avec succès`, "success");
      if (errorCount > 0) showToast(`${errorCount} taxe(s) affectée(s) mais erreur génération échéances`, "warning");
    } catch (error) {
      console.error("Erreur:", error);
      showToast("Erreur lors de l'affectation des taxes", "danger");
    } finally {
      setAssigningTaxes(false);
    }
  };

  const handleRemoveTax = async () => {
    if (!taxToRemove || !contribuable) return;
    setRemovingTax(true);
    try {
      let activiteContribuable = taxToRemove.activite_contribuable;
      if (!activiteContribuable && taxToRemove.activityId) {
        const foundSubAccount = subAccounts.find(
          sub => String(sub.contribuable_id) === String(taxToRemove.activityId)
        );
        if (foundSubAccount?.activite_contribuable) {
          activiteContribuable = foundSubAccount.activite_contribuable;
        }
      }
      if (!activiteContribuable) activiteContribuable = contribuable.activite_contribuable;

      await axios.put(
        `${API_BASE_URL}/taxpayers/${contribuable.contribuable_id}/remove-taxe`,
        {
          taxe_id: taxToRemove.taxe_id,
          activite_contribuable: activiteContribuable,
          reason: removeTaxReason.trim() || "Mise à zéro manuelle"
        },
        { headers: getHeaders() }
      );

      setShowRemoveTaxModal(false);
      setTaxToRemove(null);
      setRemoveTaxReason("");
      showToast(`Taxe mise à zéro avec succès`, "success");
      await fetchContribuableData();
    } catch (error) {
      showToast(error.response?.data?.message || "Erreur lors du retrait de la taxe", "danger");
    } finally {
      setRemovingTax(false);
    }
  };

  const handleUpdateContribuable = async () => {
    if (!contribuable) return;
    setUpdatingContact(true);
    try {
      const updateData = {
        nom_contribuable: editForm.nom_contribuable,
        telephone: editForm.telephone,
        email: editForm.email,
        adresse: editForm.adresse,
        activite_contribuable: editForm.activite_contribuable
      };
      await axios.put(`${TAXPAYERS_ENDPOINT}/${contribuable.contribuable_id}`, updateData, { headers: getHeaders() });

      setContribuable({ ...contribuable, ...updateData });
      setShowEditModal(false);
      showToast("Contribuable modifié avec succès", "success");
      await fetchContribuableData();
    } catch (error) {
      showToast("Erreur lors de la modification", "danger");
    } finally {
      setUpdatingContact(false);
    }
  };

  const handleUpdateTaxAmount = async () => {
    if (!selectedTax || !contribuable) {
      showToast("Aucune taxe ou contribuable sélectionné", "warning");
      return;
    }
    setSavingTax(true);
    const normalizedFrequency = normalizeFrequency(editTaxFrequency);
    const activiteContribuable = selectedTax.activite_contribuable ||
                                selectedTax._original?.activite_contribuable ||
                                contribuable.activite_contribuable || null;

    const payload = {
      usager_id: contribuable.contribuable_id,
      taxe_id: selectedTax.taxe_id,
      montant_personnalise: parseFloat(editTaxAmount),
      date_debut: editTaxStartDate || null,
      frequence: normalizedFrequency,
      recalculer_echeances: true
    };
    if (activiteContribuable) payload.activite_contribuable = activiteContribuable;

    try {
      const response = await axios.put(`${TAXPAYERS_ENDPOINT}/taxes/usager/customize`, payload, { headers: getHeaders() });
      if (response.data?.success || response.status === 200) {
        showToast("Montant par échéance modifié avec succès", "success");
        setShowEditTaxModal(false);
        await fetchContribuableData();
      } else {
        showToast(response.data?.message || "Erreur lors de la modification", "danger");
      }
    } catch (error) {
      showToast(error.response?.data?.message || error.message || "Erreur lors de la modification", "danger");
    } finally {
      setSavingTax(false);
    }
  };

  const handleUpdateEcheance = async () => {
    if (!selectedEcheance || !contribuable) return;
    setSavingEcheance(true);
    try {
      const response = await axios.put(
        `${API_BASE_URL}/terms/${selectedEcheance.echeance_id || selectedEcheance.id}`,
        {
          montant: parseFloat(editEcheanceAmount),
          date_echeance: editEcheanceDate,
          usager_id: contribuable.contribuable_id
        },
        { headers: getHeaders() }
      );
      if (response.data?.success || response.status === 200) {
        showToast("Échéance modifiée avec succès", "success");
        setShowEditEcheanceModal(false);
        await fetchContribuableData();
      } else {
        showToast(response.data?.message || "Erreur lors de la modification", "danger");
      }
    } catch (error) {
      showToast(error.response?.data?.message || "Erreur lors de la modification", "danger");
    } finally {
      setSavingEcheance(false);
    }
  };

  const generateEcheances = async (usagerId, taxeId, frequence, dateDebut = null) => {
    try {
      let nombrePeriodes = 12;
      switch (frequence) {
        case 'monthly': nombrePeriodes = 12; break;
        case 'quarterly': nombrePeriodes = 4; break;
        case 'semiannual': nombrePeriodes = 2; break;
        case 'annual': nombrePeriodes = 1; break;
        case 'daily': nombrePeriodes = 365; break;
        case 'one_off': nombrePeriodes = 1; break;
        default: nombrePeriodes = 12;
      }
      let startDate = dateDebut || `${new Date().getFullYear()}-01-01`;
      const payload = {
        usager_id: parseInt(usagerId),
        taxe_id: String(taxeId),
        frequence,
        date_debut: startDate,
        nombre_periodes: nombrePeriodes
      };
      const response = await axios.post(`${API_BASE_URL}/terms/generate`, payload, { headers: getHeaders() });
      return response.data && (response.data.code === 201 || response.data.code === 200);
    } catch (error) {
      console.error('Erreur génération échéances:', error);
      return false;
    }
  };

  // ==================== ACTIVITÉ JOURNALIÈRE ====================

  const fetchActivityData = async () => {
    if (!contribuable?.contribuable_id) return;
    setLoadingActivity(true);
    try {
      const paymentsData = transactions.map(payment => ({
        id: `payment_${payment.id}`, type: "paiement", date: payment.date_paiement,
        title: payment.statut === "completed" ? "Paiement réussi" : payment.statut === "failed" ? "Échec de paiement" : "Paiement en attente",
        description: payment.taxe?.titre || "Paiement de taxe",
        montant: parseFloat(payment.montant),
        color: payment.statut === "completed" ? "success" : payment.statut === "failed" ? "danger" : "warning",
        reference: payment.reference_paiement,
        badges: [{ bg: payment.statut === "completed" ? "success" : payment.statut === "failed" ? "danger" : "warning", text: payment.methode }],
        agent: payment.agent?.full_name || "Agent"
      }));

      const echeancesData = echeances.map(echeance => {
        let statusType = "Échéance créée", color = "primary";
        if (echeance.statut === "completed") { statusType = "Échéance soldée"; color = "success"; }
        else if (echeance.statut === "partial") { statusType = "Paiement partiel"; color = "warning"; }
        else { statusType = "Échéance en attente"; color = "secondary"; }
        return {
          id: `echeance_${echeance.id}`, type: "echeance", date: echeance.created_at,
          title: statusType,
          description: `Échéance pour ${echeance.taxe?.titre || "Taxe"}${echeance._activityName ? ` (${echeance._activityName})` : ''}`,
          montant: parseFloat(echeance.montant_initial),
          color,
          reference: echeance.reference,
          badges: [
            { bg: color, text: `Taxe ID: ${echeance.taxe_id}` },
            ...(echeance._activityName ? [{ bg: "info", text: echeance._activityName }] : [])
          ],
          details: echeance.montant_paye
            ? `Payé: ${formatCurrency(echeance.montant_paye)} / ${formatCurrency(echeance.montant_initial)}`
            : `Montant: ${formatCurrency(echeance.montant_initial)}`
        };
      });

      const modificationData = [];
      if (contribuable.created_at) {
        modificationData.push({
          id: "creation_compte", type: "modification", date: contribuable.created_at,
          title: "Création du compte",
          description: "Le compte contribuable a été créé",
          color: "info",
          badges: [{ bg: "info", text: "Nouveau compte" }],
          agent: contribuable?.admin?.full_name || "Système"
        });
      }
      if (contribuable.updated_at && contribuable.updated_at !== contribuable.created_at) {
        modificationData.push({
          id: "maj_compte", type: "modification", date: contribuable.updated_at,
          title: "Mise à jour des informations",
          description: "Les informations du contribuable ont été mises à jour",
          color: "info",
          badges: [{ bg: "info", text: "Mis à jour" }]
        });
      }

      const allActivities = [...paymentsData, ...echeancesData, ...modificationData]
        .sort((a, b) => new Date(b.date) - new Date(a.date));
      setActivityData(allActivities);
    } catch {
      setActivityData([]);
    } finally {
      setLoadingActivity(false);
    }
  };

  const filteredActivity = activityData
    .filter(a => activityFilter === "all" || a.type === activityFilter)
    .slice((activityPage - 1) * 10, activityPage * 10);

  const refreshActivity = () => fetchActivityData();

  // ==================== IMPRESSION ====================

  const generateBordereauPaiement = async (echeance) => {
    const receiptNumber = echeance?.reference || echeance?.id || `RCP-${Date.now()}`;
    const montantInitial = parseFloat(echeance?.montant_initial || echeance?.montant_attendu || 0);
    const montantPaye = parseFloat(echeance?.montant_paye || 0);
    const montantRestant = Math.max(0, montantInitial - montantPaye);
    const currentDate = new Date();
    const dueDate = echeance?.date_echeance ? new Date(echeance.date_echeance) : new Date();
    const periodLabel = `${dueDate.toLocaleString('fr-FR', { month: 'long' })} ${dueDate.getFullYear()}`;
    const communeNom = localiteInfo?.commune || "";
    const villeNom = localiteInfo?.ville || "";
    const provinceNom = localiteInfo?.province || "";
    const paysNom = localiteInfo?.pays || "RDC";
    const adresseComplete = localiteInfo?.adresseComplete || contribuable?.adresse || "Non spécifiée";

    const qrData = JSON.stringify({
      reference: receiptNumber, montant: montantPaye, devise: defaultCurrency,
      date: echeance?.date_paiement || new Date().toISOString(),
      contribuable: contribuable?.nom_contribuable,
      taxe: echeance?.taxe?.titre,
      periode: periodLabel
    });

    let qrCodeBase64 = '';
    try {
      qrCodeBase64 = await QRCode.toDataURL(qrData, {
        width: 120, margin: 1, color: { dark: '#1a3c5e', light: '#ffffff' }
      });
    } catch (err) { console.error("Erreur génération QR Code:", err); }

    const htmlContent = `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<title>Bordereau - ${receiptNumber}</title>
<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
body { font-family: 'Arial', sans-serif; background: white; }
@media print { @page { size: A5; margin: 0.5cm; } }
.receipt { max-width: 148mm; margin: 0 auto; padding: 5mm; }
.header { border-bottom: 2px solid #1a3c5e; padding-bottom: 10px; margin-bottom: 15px; }
.header-top { display: flex; justify-content: center; align-items: center; margin-bottom: 10px; }
.logo-section { display: flex; align-items: center; gap: 12px; }
.logo { height: 60px; }
.maison-nom { font-size: 14px; font-weight: bold; color: #1a3c5e; }
.maison-ville { font-size: 10px; color: #6c757d; }
.receipt-meta { display: flex; justify-content: space-between; margin-top: 10px; padding-top: 8px; border-top: 0.5px dashed #dee2e6; }
.meta-label { font-size: 8px; text-transform: uppercase; color: #6c757d; }
.meta-value { font-size: 10px; font-weight: bold; color: #1a3c5e; }
.title h2 { font-size: 14px; color: #28a745; text-transform: uppercase; text-align: center; margin: 15px 0; }
.sections { display: flex; gap: 20px; margin-bottom: 20px; }
.section { flex: 1; }
.section-title { font-size: 10px; font-weight: bold; color: #1a3c5e; border-bottom: 1px solid #e0e0e0; padding-bottom: 5px; margin-bottom: 10px; }
.info-line { margin-bottom: 8px; font-size: 9px; }
.info-label { color: #6c757d; min-width: 70px; display: inline-block; font-size: 8px; }
.info-value { color: #2c3e50; font-weight: 500; font-size: 9px; }
.amount-table { background: #f8f9fa; padding: 10px; margin: 15px 0; border-radius: 6px; }
.amount-row { display: flex; justify-content: space-between; padding: 5px 0; font-size: 10px; }
.amount-row.total { margin-top: 5px; padding-top: 8px; border-top: 1.5px solid #1a3c5e; font-size: 11px; font-weight: bold; }
.status-box { text-align: center; margin: 15px 0; padding: 8px; background: #d4edda; color: #155724; border-radius: 6px; font-size: 9px; font-weight: bold; }
.qrcode-section { display: flex; justify-content: center; margin: 15px 0; padding: 10px; background: #f8f9fa; border-radius: 8px; }
.qrcode-image { width: 100px; height: 100px; }
.commune-coords { margin-top: 8px; font-size: 7px; color: #6c757d; text-align: center; padding-top: 8px; }
</style>
</head>
<body>
<div class="receipt">
<div class="header">
<div class="header-top">
<div class="logo-section">
<img src="${mairieLogo}" alt="Logo" class="logo" />
<div>
<div class="maison-nom">MAISON COMMUNALE${communeNom ? ` DE ${communeNom.toUpperCase()}` : ''}</div>
<div class="maison-ville">${villeNom} ${provinceNom} - ${paysNom}</div>
</div>
</div>
</div>
<div class="receipt-meta">
<div><div class="meta-label">QUITTANCE N°</div><div class="meta-value">${receiptNumber}</div></div>
<div><div class="meta-label">DATE D'ÉMISSION</div><div class="meta-value">${formatDate(currentDate)}</div></div>
</div>
</div>
<div class="title"><h2>QUITTANCE DE PAIEMENT</h2></div>
<div class="sections">
<div class="section">
<div class="section-title">CONTRIBUABLE</div>
<div class="info-line"><span class="info-label">Nom</span><span class="info-value">${contribuable?.nom_contribuable || 'Non spécifié'}</span></div>
<div class="info-line"><span class="info-label">ID</span><span class="info-value">${contribuable?.contribuable_id || 'N/A'}</span></div>
<div class="info-line"><span class="info-label">Tél</span><span class="info-value">${contribuable?.telephone || 'Non spécifié'}</span></div>
<div class="info-line"><span class="info-label">Adresse</span><span class="info-value">${adresseComplete}</span></div>
</div>
<div class="section">
<div class="section-title">TAXE</div>
<div class="info-line"><span class="info-label">Désignation</span><span class="info-value">${echeance?.taxe?.titre || 'Taxe'}</span></div>
<div class="info-line"><span class="info-label">Période</span><span class="info-value">${periodLabel}</span></div>
</div>
</div>
<div class="amount-table">
<div class="amount-row"><span>Montant initial</span><span>${formatCurrency(montantInitial)}</span></div>
<div class="amount-row"><span>Montant payé</span><span style="color:#28a745">${formatCurrency(montantPaye)}</span></div>
<div className="amount-row total"><span>RESTE À PAYER</span><span>${formatCurrency(montantRestant)}</span></div>
</div>
<div class="status-box">${montantPaye >= montantInitial ? 'PAYÉ INTÉGRALEMENT' : 'PAIEMENT PARTIEL'}</div>
${qrCodeBase64 ? `<div class="qrcode-section"><img src="${qrCodeBase64}" alt="QR" class="qrcode-image" /></div>` : ''}
<div class="commune-coords">Maison Communale${communeNom ? ` de ${communeNom}` : ''} | ${villeNom} ${provinceNom}</div>
</div>
</body>
</html>`;

    const iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = 'none';
    document.body.appendChild(iframe);
    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(htmlContent);
    iframeDoc.close();
    iframe.contentWindow.onload = () => {
      iframe.contentWindow.print();
      setTimeout(() => {
        if (document.body.contains(iframe)) document.body.removeChild(iframe);
      }, 1000);
    };
  };

  const generateThermalReceiptText = (echeance) => {
    const receiptNumber = `RCP-${echeance.id?.toString().slice(-6) || Math.floor(Math.random() * 1000000)}-${new Date().getFullYear()}`;
    const montantInitial = parseFloat(echeance.montant_initial || echeance.montant_attendu || 0);
    const montantPaye = parseFloat(echeance.montant_paye || 0);
    const montantRestant = Math.max(0, montantInitial - montantPaye);
    const dueDate = new Date(echeance.date_echeance);
    const periodLabel = `${dueDate.toLocaleString('fr-FR', { month: 'long' })} ${dueDate.getFullYear()}`;
    const pourcentagePaiement = montantInitial > 0 ? Math.round((montantPaye / montantInitial) * 100) : 0;
    const ESC = '\x1B', GS = '\x1D';
    const init = ESC + '\x40', center = ESC + '\x61\x01', left = ESC + '\x61\x00';
    const bold = ESC + '\x45\x01', boldOff = ESC + '\x45\x00';
    const doubleSize = GS + '\x21\x30', normal = GS + '\x21\x00';
    const cut = GS + '\x56\x42\x00';
    const separator = '='.repeat(32) + '\n';
    const dashLine = '-'.repeat(32) + '\n';
    const adresseComplete = localiteInfo?.adresseComplete || contribuable?.adresse || 'Non spécifiée';

    return (
      init + center + doubleSize + 'SYNCTAXE\n' + normal +
      center + 'Solutions fiscales innovantes\n' + separator +
      left + bold + 'REÇU DE PAIEMENT\n' + boldOff +
      'N°: ' + receiptNumber + '\n' +
      'Date: ' + new Date().toLocaleString('fr-FR') + '\n' + separator +
      bold + 'CONTRIBUABLE\n' + boldOff +
      'Nom: ' + (contribuable?.nom_contribuable || 'Non spécifié') + '\n' +
      'ID: ' + (contribuable?.contribuable_id || 'N/A') + '\n' +
      'Tél: ' + (contribuable?.telephone || 'Non spécifié') + '\n' +
      'Adresse: ' + adresseComplete.substring(0, 30) + '\n' + dashLine +
      bold + 'TAXE\n' + boldOff +
      'Désignation: ' + (echeance.taxe?.titre || 'Taxe') + '\n' +
      'Période: ' + periodLabel + '\n' +
      'Échéance: ' + formatDate(echeance.date_echeance) + '\n' + dashLine +
      bold + 'MONTANTS\n' + boldOff +
      'Initial: ' + formatCurrency(montantInitial) + '\n' +
      'Payé: ' + formatCurrency(montantPaye) + '\n' +
      'Restant: ' + formatCurrency(montantRestant) + '\n' + dashLine +
      'Progression: ' + pourcentagePaiement + '%\n' + separator +
      center + 'MERCI DE VOTRE CONFIANCE\n' +
      center + 'www.synctaxes.com\n' + '\n\n\n\n' + cut
    );
  };

  const scanBluetoothDevices = async () => {
    if (!navigator.bluetooth) {
      showToast("Web Bluetooth non supporté. Utilisez Chrome.", "warning");
      return;
    }
    setScanningDevices(true);
    setAvailableDevices([]);
    setBluetoothStatus("Recherche d'appareils Bluetooth...");
    try {
      const device = await navigator.bluetooth.requestDevice({
        acceptAllDevices: true,
        optionalServices: ['00001101-0000-1000-8000-00805f9b34fb', '000018f0-0000-1000-8000-00805f9b34fb']
      });
      const deviceInfo = { name: device.name || "Appareil sans nom", id: device.id, modelName: device.name || "Non disponible" };
      setAvailableDevices([deviceInfo]);
      setBluetoothStatus(`Appareil trouvé: ${deviceInfo.name}`);
      showToast(`✅ ${deviceInfo.name} détecté!`, "success");
    } catch (error) {
      if (error.message.includes("User cancelled")) setBluetoothStatus("Recherche annulée");
      else setBluetoothStatus("Aucun appareil trouvé.");
    } finally {
      setScanningDevices(false);
    }
  };

  const testDeviceConnection = async (device) => {
    setPrintingBluetooth(true);
    setBluetoothStatus(`Connexion à ${device.name}...`);
    try {
      const server = await device.gatt.connect();
      const services = await server.getPrimaryServices();
      const printServices = services.map(s => s.uuid).filter(s =>
        s.includes('1101') || s.includes('18f0') || s.includes('18f1') || s.includes('110a'));
      if (printServices.length > 0) {
        setBluetoothStatus(`✅ ${device.name} compatible`);
        showToast(`${device.name} compatible`, "success");
      } else {
        setBluetoothStatus(`⚠️ ${device.name} peut ne pas être une imprimante`);
      }
      await server.disconnect();
      return true;
    } catch (error) {
      setBluetoothStatus(`Erreur: ${error.message}`);
      showToast(`Impossible de se connecter à ${device.name}`, "danger");
      return false;
    } finally {
      setPrintingBluetooth(false);
      setTimeout(() => setBluetoothStatus(''), 5000);
    }
  };

  const printOnSelectedDevice = async (echeance, device) => {
    setPrintingBluetooth(true);
    setBluetoothStatus(`Connexion à ${device.name}...`);
    try {
      const server = await device.gatt.connect();
      let service = null;
      const serviceUuids = ['00001101-0000-1000-8000-00805f9b34fb', '000018f0-0000-1000-8000-00805f9b34fb'];
      for (const uuid of serviceUuids) {
        try { service = await server.getPrimaryService(uuid); if (service) break; } catch { continue; }
      }
      if (!service) throw new Error("Aucun service d'impression");
      let characteristic = null;
      const characteristics = await service.getCharacteristics();
      for (const char of characteristics) {
        if (char.properties.write || char.properties.writeWithoutResponse) { characteristic = char; break; }
      }
      if (!characteristic) throw new Error("Caractéristique non trouvée");
      const receiptText = generateThermalReceiptText(echeance);
      const encoder = new TextEncoder();
      const data = encoder.encode(receiptText);
      const chunkSize = 200;
      for (let i = 0; i < data.length; i += chunkSize) {
        await characteristic.writeValue(data.slice(i, i + chunkSize));
        await new Promise(resolve => setTimeout(resolve, 50));
      }
      showToast(`Reçu imprimé sur ${device.name}`, "success");
      await server.disconnect();
      return true;
    } catch (error) {
      showToast(`Erreur d'impression: ${error.message}`, "danger");
      return false;
    } finally {
      setPrintingBluetooth(false);
      setTimeout(() => setBluetoothStatus(''), 3000);
    }
  };

  const handlePrintReceipt = (echeance, format = 'a5') => {
    if (format === 'pos') {
      setSelectedEcheance(echeance);
      scanBluetoothDevices();
      setShowDeviceModal(true);
    } else {
      generateBordereauPaiement(echeance);
    }
  };

  const requestSort = (key) => {
    let direction = 'ascending';
    if (sortConfig.key === key && sortConfig.direction === 'ascending') direction = 'descending';
    setSortConfig({ key, direction });
  };

  const handleTaxSelection = (taxId) =>
    setSelectedTaxes(prev => prev.includes(taxId) ? prev.filter(id => id !== taxId) : [...prev, taxId]);

  // ==================== FILTRAGE ÉCHÉANCES ====================

  const getFilteredAndPaginatedEcheances = () => {
    let filtered = [...echeances];
    if (echeanceSearchTerm) {
      const searchLower = echeanceSearchTerm.toLowerCase();
      filtered = filtered.filter(e => {
        const dueDate = new Date(e.date_echeance);
        const periodLabel = `${dueDate.toLocaleString('fr-FR', { month: 'long' })} ${dueDate.getFullYear()}`;
        return periodLabel.toLowerCase().includes(searchLower) ||
               (e.taxe?.titre || 'Taxe').toLowerCase().includes(searchLower) ||
               (e._activityName && e._activityName.toLowerCase().includes(searchLower));
      });
    }
    if (echeanceActivityFilter !== "all") {
      if (echeanceActivityFilter === "main") {
        filtered = filtered.filter(e => e._activityId === null);
      } else {
        const targetId = parseInt(echeanceActivityFilter);
        filtered = filtered.filter(e => e._activityId === targetId);
      }
    }
    const startIndex = (echeanceCurrentPage - 1) * echeanceItemsPerPage;
    const paginated = filtered.slice(startIndex, startIndex + echeanceItemsPerPage);
    const totalPages = Math.ceil(filtered.length / echeanceItemsPerPage);
    return { filtered, paginated, totalPages, totalItems: filtered.length };
  };

  const handleEcheanceSearch = (value) => { setEcheanceSearchTerm(value); setEcheanceCurrentPage(1); };

  const getStats = () => {
    if (!contribuable) return null;
    const totalInitial = parseFloat(globalStats.total_initial || 0);
    const totalPaye = parseFloat(globalStats.total_paye || 0);
    const totalRestant = parseFloat(globalStats.total_restant || 0);
    const totalEcheances = parseInt(globalStats.total_echeances || 0);
    const tauxRecouvrement = parseFloat(globalStats.taux_recouvrement || 0);
    return { totalInitial, totalPaye, totalRestant, totalEcheances, tauxRecouvrement, paiementPercentage: tauxRecouvrement };
  };

  // ==================== MODIFICATION D'ACTIVITÉ ====================

  const fetchAvailableActivitiesForModify = async (currentActivityId) => {
    try {
      setLoadingModifyActivities(true);
      const response = await axios.get(`${API_BASE_URL}/activites?has_tax=yes`, { headers: getHeaders() });
      let activities = [];
      if (Array.isArray(response.data)) activities = response.data;
      else if (response.data?.data && Array.isArray(response.data.data)) activities = response.data.data;

      const assignedActivityIds = new Set();
      if (contribuable?.activite_contribuable) assignedActivityIds.add(String(contribuable.activite_contribuable));
      subAccounts.forEach(sub => {
        if (sub.activite_contribuable) assignedActivityIds.add(String(sub.activite_contribuable));
      });
      assignedTaxes.forEach(tax => {
        if (tax.activite_contribuable) assignedActivityIds.add(String(tax.activite_contribuable));
      });

      const currentId = String(currentActivityId);
      const filtered = activities.filter(act => {
        const activityId = String(act.id_export || act.code_category || act.id);
        return activityId !== currentId && !assignedActivityIds.has(activityId);
      });

      const formatted = filtered.map(act => ({
        value: String(act.id_export || act.code_category || act.id),
        label: `${act.name}${act.cat_name ? ` - ${act.cat_name}` : ''}${act.description ? ` (${act.description})` : ''}`,
        original: act
      }));
      setAvailableActivitiesForModify(formatted);
    } catch (error) {
      console.error("Erreur chargement activités:", error);
      setAvailableActivitiesForModify([]);
    } finally {
      setLoadingModifyActivities(false);
    }
  };

  const checkActivityChange = async (contribuableId, newActivityId) => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/taxpayers/${contribuableId}/verifier-activite`,
        { headers: getHeaders() }
      );
      setModifyActivityVerification(response.data.data);
      return response.data.data;
    } catch (error) {
      console.error("Erreur vérification:", error);
      return null;
    }
  };

  const handleModifyActivity = async () => {
    if (!selectedNewActivityForModify || !selectedActivityToModify) {
      showToast("Veuillez sélectionner une nouvelle activité", "warning");
      return;
    }
    setModifyingActivity(true);
    try {
      const response = await axios.put(
        `${API_BASE_URL}/taxpayers/${selectedActivityToModify.contribuable_id}/modifier-activite`,
        {
          nouvelle_activite_id: String(selectedNewActivityForModify.value),
          regenerer_echeances: regenerateEcheancesAfterModify,
          date_debut_echeances: modifyActivityStartDate || new Date().toISOString().split('T')[0]
        },
        { headers: getHeaders() }
      );
      if (response.data.success) {
        showToast(response.data.message, "success");
        setShowModifyActivityModal(false);
        await fetchContribuableData();
        setSelectedActivityToModify(null);
        setSelectedNewActivityForModify(null);
        setModifyActivityVerification(null);
      }
    } catch (error) {
      showToast(error.response?.data?.message || "Erreur lors de la modification", "danger");
    } finally {
      setModifyingActivity(false);
    }
  };

  const openModifyActivityModal = async (activity) => {
    setLoadingModalOpen(true);
    try {
      setSelectedActivityToModify(activity);
      await fetchAvailableActivitiesForModify(activity.activite_contribuable || activity.activityId);
      await checkActivityChange(activity.contribuable_id, null);
      setShowModifyActivityModal(true);
    } catch (error) {
      showToast("Erreur lors du chargement des données", "danger");
    } finally {
      setLoadingModalOpen(false);
    }
  };

  // ==================== NOTE DE TAXATION ====================
// ==================== AVIS DE PASSAGE ET DE RECOUVREMENT ====================


// Image de la barre verticale colorée (extraite du document Word d'origine)
const generateAvisPassagePDF = () => {
  if (!contribuable) {
    showToast("Aucun contribuable sélectionné", "warning");
    return;
  }

  // Récupération des infos de localisation
  let villeNom = "", communeNom = "", quartierNom = "";
  if (localiteInfo?.chaineComplete?.length > 0) {
    localiteInfo.chaineComplete.forEach(loc => {
      if (loc.type_code === 1001 && !villeNom) villeNom = loc.nom;
      if (loc.type_code === 1000 && !communeNom) communeNom = loc.nom;
      if (loc.type_code === 1002 && !quartierNom) quartierNom = loc.nom;
    });
  }
  if (!villeNom) villeNom = localiteInfo?.ville || "Kinshasa";
  if (!communeNom) communeNom = localiteInfo?.commune || "Lemba";
  if (!quartierNom) quartierNom = localiteInfo?.quartier || "";

  const denomination = contribuable.nom_contribuable || "";
  const annee = new Date().getFullYear();

  // Pointillés (mêmes caractères « … » que le document Word)
  const dots = (n) => "…".repeat(n);

const htmlContent = `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<title>Avis de Passage - ${denomination}</title>
<style>
  /* Page Lettre, marges aérées */
    /* Marges ajustées : un peu plus grandes que 15mm, mais plus petites que 25mm */
  @page { size: 215.9mm 279.4mm; margin: 18mm 18mm 18mm 18mm; }
  * { box-sizing: border-box; }
  html, body {
    margin: 0;
    padding: 0;
    background: white;
    color: #000;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
  body {
    /* APPLICATION DE LA POLICE ARIAL SANS-SERIF PARTOUT */
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12pt;
    line-height: 1.55; /* Interlignage intermédiaire */
    padding: 0; 
  }
  p { margin: 0 0 15px 0; }

  /* ===== En-tête ===== */
  .entete {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 30px;
    position: relative;
  }
  .entete .logos {
    display: flex;
    align-items: center;
  }
  .entete .logo {
    width: 120px; /* Ajusté pour nrf.png */
    height: auto;
  }
  .entete .infos {
    text-align: right;
    font-family: Arial, Helvetica, sans-serif; 
    line-height: 1.4;
    padding-top: 10px;
  }
  .entete .infos .ville {
    font-weight: bold;
    font-size: 12pt;
    color: #1a3c5e;
  }
  .entete .infos .commune {
    font-weight: bold;
    font-size: 12pt;
    color: #FF0000;
    margin-bottom: 5px;
  }
  .entete .infos .service {
    color: #00B0F0;
    font-size: 12pt;
  }
  .entete .ligne-separation {
    border-top: 1.5px solid #000;
    margin-bottom: 30px;
  }

  /* ===== Titre ===== */
  .titre {
    text-align: center;
    font-size: 14pt;
    font-weight: bold;
    text-transform: uppercase;
    line-height: 1.5;
    margin-bottom: 35px;
    font-family: Arial, Helvetica, sans-serif; 
  }
  .titre span {
    text-decoration: underline;
  }

  /* ===== Corps ===== */
  .justifie { 
    text-align: justify; 
    font-family: Arial, Helvetica, sans-serif; 
  }
  .destinataire { 
    text-indent: 15mm;
    margin-bottom: 25px;
  }
  
  .liste {
    margin-bottom: 25px;
    padding-left: 15mm;
    font-family: Arial, Helvetica, sans-serif; 
  }
  .liste-item {
    margin-bottom: 10px;
    text-align: justify;
  }

  .nb {
    text-align: justify;
    margin-bottom: 40px;
    padding: 15px;
    background-color: #fffcf5;
    border: 1px solid #e0d0a0;
    border-radius: 4px;
    font-family: Arial, Helvetica, sans-serif; 
  }

  /* ===== Signature ===== */
  .signature {
    text-align: center;
    margin-top: 40px;
    font-family: Arial, Helvetica, sans-serif; 
  }
  .signature-date {
    margin-bottom: 30px;
  }
  .signature-titre {
    font-weight: bold;
    margin-bottom: 30px;
  }
</style>
</head>
<body>

  <div class="entete">
    <div class="logos">
      <!-- Utilisation de l'image nrf.png importée dans votre composant -->
      <img class="logo" src="${mairieLogo}" alt="Logo" />
    </div>
    <div class="infos">
      <div class="ville">VILLE DE KINSHASA</div>
      <div class="commune">Commune de <strong>${communeNom}</strong></div>
      <div class="service">Service de L’Economie</div>
    </div>
  </div>
  <div class="ligne-separation"></div>

  <div class="titre">
    AVIS DE PASSAGE ET DE RECOUVREMENT DE LA TAXE<br />
    <span>PROFESSIONNELLE ANNUELLE</span>
  </div>

  <p class="justifie destinataire">
    Madame, Mademoiselle, Monsieur, Responsable des ETS(STE) <strong>${denomination || dots(25)}</strong><br />
    Sis(e) au N° ${dots(21)}, de l’avenue ${dots(30)}<br />
    quartier <strong>${quartierNom ? quartierNom : dots(28)}</strong>, Commune de <strong>${communeNom}</strong>;
  </p>

  <p class="justifie">
    En exécution de l’ordre de mission sur les opérations d’identification des opérateurs économiques, d’enrôlement éléments d’assiette de la Taxe Professionnelle Annuelle et de son recouvrement pour l’exercice en cours, il vous est demandé de nous apprêter les éléments suivants, dans les 48 heures qui suivront la réception du présent avis&nbsp;:
  </p>

  <div class="liste">
    <div class="liste-item">1. Les copies des Autorisations d’ouverture de chaque activité exercée&nbsp;;</div>
    <div class="liste-item">2. Les preuves de paiement de la Taxe Professionnelle Annuelle <strong>${annee}</strong>.</div>
  </div>

  <div class="nb">
    <strong>N.B :</strong> Tout refus de collaboration, toute fausse déclaration, toute dissimulation d’activités ou toute obstruction au recensement, expose le contrevenant aux sanctions prévues par les textes législatifs et réglementaires en vigueur.
  </div>

  <div class="signature">
    <div class="signature-date">
      Fait à <strong>${villeNom || 'Kinshasa'}</strong>, le &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/ <strong>${annee}</strong>
    </div>
    <div class="signature-titre">
      LE CHEF D’EQUIPE
    </div>
  </div>

</body>
</html>`;

  // Création de l'iframe pour l'impression
  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = 'none';
  document.body.appendChild(iframe);

  const iframeDoc = iframe.contentWindow.document;
  iframeDoc.open();
  iframeDoc.write(htmlContent);
  iframeDoc.close();

  // On attend un court instant (500ms) pour s'assurer que l'image locale nrf.png est chargée
  iframe.contentWindow.onload = () => {
    setTimeout(() => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      setTimeout(() => {
        if (document.body.contains(iframe)) document.body.removeChild(iframe);
      }, 1000);
    }, 500);
  };

  showToast("Document prêt pour l'impression / PDF", "success");
};


  const generateFicheRecensement = async () => {
    let documentInfo = { id_interne: null, date_create: null };
    try {
      const documentResponse = await axios.get(`${API_BASE_URL}/document_interne`, { headers: getHeaders() });
      if (documentResponse.data?.id_interne) {
        documentInfo.id_interne = documentResponse.data.id_interne;
        documentInfo.date_create = documentResponse.data.date_create;
      } else {
        documentInfo.id_interne = `NT-${Date.now()}`;
        documentInfo.date_create = new Date().toISOString().slice(0, 19).replace('T', ' ');
      }
    } catch {
      documentInfo.id_interne = `NT-${Date.now()}`;
      documentInfo.date_create = new Date().toISOString().slice(0, 19).replace('T', ' ');
    }

    const taxationNumber = documentInfo.id_interne;
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentDay = String(currentDate.getDate()).padStart(2, '0');
    const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');

    let villeNom = "", communeNom = "", quartierNom = "";
    if (localiteInfo?.chaineComplete?.length > 0) {
      localiteInfo.chaineComplete.forEach(loc => {
        if (loc.type_code === 1001 && !villeNom) villeNom = loc.nom;
        if (loc.type_code === 1000 && !communeNom) communeNom = loc.nom;
        if (loc.type_code === 1002 && !quartierNom) quartierNom = loc.nom;
      });
    }

    const adresseBase = contribuable?.adresse || "";
    const getDenomination = () => contribuable?.nom_contribuable || "ETS MUANA MBOKA";

    let taxeOuverture = null;
    const taxesProfessionnelles = [];
    assignedTaxes.forEach(tax => {
      const montantRestant = tax.montantRestant || 0;
      if (montantRestant === 0) return;
      const isTaxeOuverture = tax.type?.toLowerCase().includes('ouverture') ||
                              tax.type?.toLowerCase().includes('autorisation') ||
                              tax.type?.toLowerCase().includes('installation');
      if (isTaxeOuverture) taxeOuverture = tax;
      else taxesProfessionnelles.push(tax);
    });

    const montantOuverture = taxeOuverture?.montantRestant || 0;
    const montantOuvertureFormatted = montantOuverture > 0
      ? montantOuverture.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
      : "-";
    const totalTaxesPro = taxesProfessionnelles.reduce((sum, tax) => sum + (tax.montantRestant || 0), 0);
    const montantTotal = montantOuverture + totalTaxesPro;

    const generateTaxRows = () => {
      let html = '';
      let lineNumber = 1;
      if (montantOuverture > 0) {
        html += `<tr><td style="padding:8px;border:1px solid #000;text-align:center;">${String(lineNumber).padStart(2, '0')}</td><td style="padding:8px;border:1px solid #000;">Autorisation d'ouverture</td><td style="padding:8px;border:1px solid #000;text-align:right;">${montantOuvertureFormatted}</td></tr>`;
        lineNumber++;
      }
      taxesProfessionnelles.forEach(tax => {
        const montantTax = tax.montantRestant || 0;
        const montantFormatted = montantTax.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
        let libelle = tax.type || 'Taxe professionnelle';
        if (tax.activityName && tax.activityName !== 'Activité') libelle = `${libelle} (${tax.activityName})`;
        html += `<tr><td style="padding:8px;border:1px solid #000;text-align:center;">${String(lineNumber).padStart(2, '0')}</td><td style="padding:8px;border:1px solid #000;">${libelle}</td><td style="padding:8px;border:1px solid #000;text-align:right;">${montantFormatted}</td></tr>`;
        lineNumber++;
      });
      if (montantOuverture === 0 && taxesProfessionnelles.length === 0) {
        html += `<tr><td colspan="3" style="padding:8px;border:1px solid #000;text-align:center;">Aucune taxe due</td></tr>`;
      }
      return html;
    };

    const getTaxationNumber = () => `${taxationNumber || ' '} / 441 / LB / ECON / ${currentYear}`;
    const hasTaxesDue = montantTotal > 0;

    const htmlContent = `<!DOCTYPE html>
<html><head><meta charset="UTF-8"><title>Note de taxation TPA</title>
<style>
* { margin:0; padding:0; box-sizing:border-box; }
body { font-family:'Arial',sans-serif; background:white; font-size:14px; }
@media print { @page { size:A4; margin:1.5cm; } }
.document { max-width:210mm; margin:0 auto; padding:20px; }
.header { display:flex; justify-content:space-between; margin-bottom:15px; }
.logo-left img { width:150px; }
.main-title { text-align:center; margin:20px 0; }
.note-title { font-size:14px; font-weight:bold; text-decoration:underline; }
.corps { margin:15px 0; line-height:1.6; font-size:13px; }
.tax-table { width:100%; border-collapse:collapse; margin:15px 0; font-size:12px; }
.tax-table th { border:1px solid #000; padding:8px; background:#f5f5f5; }
.tax-table td { border:1px solid #000; padding:6px 8px; }
.total-row { font-weight:bold; background:#f9f9f9; }
.note-importante { margin:15px 0; font-size:11px; font-style:italic; line-height:1.4; }
.signature { margin-top:30px; text-align:center; }
.footer { margin-top:40px; font-size:10px; text-align:center; border-top:1px solid #ccc; padding-top:8px; }
</style></head>
<body><div class="document">
<div class="header"><div class="logo-left"><img src="${mairieLogo}" /></div></div>
<div class="main-title"><div class="note-title">NOTE DE TAXATION N° ${getTaxationNumber()}</div></div>
<div class="corps">
<p>Madame, Mademoiselle, Monsieur, Responsable des ETS(STE) <strong>${getDenomination()}</strong></p>
<p>Sis(e) au <strong>${adresseBase || " "}</strong>, quartier <strong>${quartierNom || "..."}</strong>, Commune de <strong>${communeNom || "Lemba"}</strong>;</p>
${hasTaxesDue ? `<p style="margin-top:8px;">Sauf erreur ou omission de notre part, vous êtes redevable envers le Trésor municipal d'un montant total de <strong>${montantTotal.toLocaleString('fr-FR')} Francs congolais</strong>, éclaté de la manière suivante :</p>` :
`<p style="margin-top:8px;">Nous vous informons que votre situation fiscale est à jour.</p>`}
</div>
${hasTaxesDue ? `
<table class="tax-table"><thead><tr><th style="width:50px;">N°</th><th>Libellé des Actes</th><th style="width:150px;">Montant dû</th></tr></thead>
<tbody>${generateTaxRows()}
<tr class="total-row"><td colspan="2" style="padding:8px;border:1px solid #000;text-align:right;font-weight:bold;">MONTANT TOTAL DÛ</td><td style="padding:8px;border:1px solid #000;text-align:right;font-weight:bold;">${montantTotal.toLocaleString('fr-FR')}</td></tr>
</tbody></table>
<div class="note-importante">
<p>Ce montant est à verser intégralement entre les mains du percepteur, endéans 8 jours francs, <strong>faute de quoi il vous sera appliqué une majoration de l'ordre de 20 %</strong>.</p>
<p style="margin-top:8px;"><strong>N.B : Ce montant de la TPA fixé conformément au canevas budgétaire de la Commune de ${communeNom || "Lemba"}, n'est pas négociable.</strong></p>
</div>` : ''}
<div class="signature">
<p>FAIT A ${villeNom.toUpperCase() || "KINSHASA"}, LE ${currentDay} / ${currentMonth} / ${currentYear}</p>
<p style="margin-top:8px;font-weight:bold;">LE CHEF DE SERVICE D'ASSIETTE</p>
</div>
<p>Visa BGM.</p>
<div class="footer"><p>VILLE DE KINSHASA - Commune de ${communeNom || "Lemba"} - Service de Comptabilité</p></div>
</div></body></html>`;

    const iframe = document.createElement('iframe');
    iframe.style.cssText = 'position:absolute;width:0;height:0;border:none;';
    document.body.appendChild(iframe);
    const iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(htmlContent);
    iframeDoc.close();
    iframe.contentWindow.onload = () => {
      iframe.contentWindow.print();
      setTimeout(() => {
        if (document.body.contains(iframe)) document.body.removeChild(iframe);
      }, 1000);
    };
  };

  // ==================== USE EFFECTS ====================

  useEffect(() => {
    fetchContribuableData();
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    if ((transactions.length > 0 || echeances.length > 0) && contribuable) {
      fetchActivityData();
    }
    // eslint-disable-next-line
  }, [transactions, echeances, contribuable]);

  // ==================== RENDU ====================

  const stats = getStats();

  const filteredTaxes = (() => {
    let filtered = [...assignedTaxes];
    if (searchTerm) filtered = filtered.filter(tax => tax.type?.toLowerCase().includes(searchTerm.toLowerCase()));
    if (selectedStatus !== "all") filtered = filtered.filter(tax => tax.realStatus === selectedStatus);
    if (taxActivityFilter !== "all") {
      const targetId = parseInt(taxActivityFilter);
      filtered = filtered.filter(tax => tax.activityId === targetId);
    }
    if (sortConfig.key) {
      filtered.sort((a, b) => {
        let aValue = a[sortConfig.key] || '', bValue = b[sortConfig.key] || '';
        if (sortConfig.key === 'montant') aValue = a.montant || 0;
        if (sortConfig.key === 'montantPaye') aValue = a.montantPaye || 0;
        if (sortConfig.key === 'montantRestant') aValue = a.montantRestant || 0;
        if (typeof aValue === 'string') { aValue = aValue.toLowerCase(); bValue = bValue.toLowerCase(); }
        return sortConfig.direction === 'ascending' ? (aValue > bValue ? 1 : -1) : (aValue < bValue ? 1 : -1);
      });
    }
    return filtered;
  })();

  const getActivityStats = () => {
    const statsByActivity = {};
    assignedTaxes.forEach(tax => {
      const activityKey = tax.activityId || 'unknown';
      const activityName = tax.activityName || 'Activité';
      if (!statsByActivity[activityKey]) {
        statsByActivity[activityKey] = {
          name: activityName, activityId: activityKey,
          totalMontant: 0, totalPaye: 0, totalRestant: 0, taxCount: 0
        };
      }
      statsByActivity[activityKey].totalMontant += tax.montant;
      statsByActivity[activityKey].totalPaye += tax.montantPaye;
      statsByActivity[activityKey].totalRestant += tax.montantRestant;
      statsByActivity[activityKey].taxCount++;
    });
    return statsByActivity;
  };

  const activityStats = getActivityStats();
  const mainActivityName = getActivityName(contribuable?.activite_contribuable);
  const totalGeneral = assignedTaxes.reduce((sum, tax) => sum + (tax.montant || 0), 0);

  if (loading || !dataLoaded) {
    return (
      <>
        <Header />
        <div className="main main-app p-3 p-lg-4" style={{ background: '#f5f7fa', minHeight: '100vh' }}>
          <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
            <Card className="border-0 shadow-sm rounded-4 text-center" style={{ maxWidth: '500px', width: '100%' }}>
              <Card.Body className="p-5">
                <div className="mb-4">
                  <div className="pulse-animation mx-auto d-flex align-items-center justify-content-center"
                       style={{ width: '80px', height: '80px', background: 'linear-gradient(135deg, #0d6efd, #0a58ca)', borderRadius: '50%' }}>
                    <Spinner animation="border" variant="light" style={{ width: '2rem', height: '2rem' }} />
                  </div>
                </div>
                <h4 className="fw-bold mb-2">Chargement en cours</h4>
                <p className="text-muted mb-4">Récupération des informations du contribuable...</p>
                <div className="d-flex justify-content-center gap-2 mb-4">
                  <div className="spinner-grow spinner-grow-sm text-primary" style={{ animationDelay: '0s' }} />
                  <div className="spinner-grow spinner-grow-sm text-primary" style={{ animationDelay: '0.15s' }} />
                  <div className="spinner-grow spinner-grow-sm text-primary" style={{ animationDelay: '0.3s' }} />
                  <div className="spinner-grow spinner-grow-sm text-primary" style={{ animationDelay: '0.45s' }} />
                  <div className="spinner-grow spinner-grow-sm text-primary" style={{ animationDelay: '0.6s' }} />
                </div>
                <small className="text-muted">
                  <InfoCircle className="me-1" size={12} />
                  Chargement optimisé (API unifiée)
                </small>
              </Card.Body>
            </Card>
          </Container>
          <style>{`
            .pulse-animation { animation: pulse 1.5s ease-in-out infinite; }
            @keyframes pulse {
              0% { transform: scale(1); opacity: 1; box-shadow: 0 0 0 0 rgba(13, 110, 253, 0.4); }
              50% { transform: scale(1.05); opacity: 0.9; box-shadow: 0 0 0 15px rgba(13, 110, 253, 0); }
              100% { transform: scale(1); opacity: 1; box-shadow: 0 0 0 0 rgba(13, 110, 253, 0); }
            }
          `}</style>
          <Footer />
        </div>
      </>
    );
  }

  if (error && !contribuable) {
    return (
      <>
        <Header />
        <div className="main main-app p-3 p-lg-4">
          <div className="container-fluid">
            <div className="text-center py-5">
              <XCircle size={80} className="text-danger mb-4" />
              <h3 className="text-danger mb-3">Contribuable non trouvé</h3>
              <p className="text-muted mb-4">{error}</p>
              <Button variant="primary" onClick={() => navigate('/contribuables/liste')} className="px-4">
                <ArrowLeft className="me-2" /> Retour à la recherche
              </Button>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <React.Fragment>
      <Header />

      <ToastContainer className="p-3" style={{ zIndex: 9999, position: 'fixed', top: '20px', right: '20px' }}>
        {toasts.map(toast => (
          <Toast key={toast.id} onClose={() => setToasts(prev => prev.filter(t => t.id !== toast.id))} delay={5000} autohide>
            <Toast.Header className={`bg-${toast.type} text-white`}>
              {toast.type === 'success' && <CheckCircle className="me-2" size={16} />}
              {toast.type === 'danger' && <XCircle className="me-2" size={16} />}
              {toast.type === 'warning' && <ExclamationCircle className="me-2" size={16} />}
              {toast.type === 'info' && <InfoCircle className="me-2" size={16} />}
              <strong className="me-auto">{toast.title}</strong>
            </Toast.Header>
            <Toast.Body>{toast.message}</Toast.Body>
          </Toast>
        ))}
      </ToastContainer>

      <div className="main main-app p-3 p-lg-4" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%)', minHeight: '100vh' }}>
        <div className="container-fluid">
          {/* En-tête */}
          <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-3">
            <div>
              <ol className="breadcrumb mb-1">
                <li className="breadcrumb-item"><Link to="/dashboard">Tableau de bord</Link></li>
                <li className="breadcrumb-item"><Link to="/agent/contribuables/liste">Contribuables</Link></li>
                <li className="breadcrumb-item active">Détails</li>
              </ol>
              <h1 className="display-7 fw-bold mb-0">Détails du contribuable</h1>
              <p className="text-muted">Gestion complète des informations</p>
            </div>
            {contribuable && (
              <div className="d-flex gap-2">
                <Button variant="outline-primary" onClick={generateFicheRecensement} className="d-flex align-items-center gap-2">
                  <Printer size={16} /> Note de taxation
                </Button>

                  <Button variant="outline-secondary" onClick={generateAvisPassagePDF} className="d-flex align-items-center gap-2">
      <FileText size={16} /> Avis de passage
    </Button>


                <Button variant="outline-success" onClick={() => {
                  fetchActivityLocalites();
                  fetchAvailableActivitiesLazy();
                  setShowAddActivityModal(true);
                }} className="d-flex align-items-center gap-2">
                  <PlusCircle size={16} /> Ajouter une activité
                </Button>
              </div>
            )}
          </div>

          {contribuable && (
            <>
              {/* Carte principale du contribuable */}
              <Card className="border-0 shadow-lg mb-4 overflow-hidden">
                <div className="bg-primary" style={{ height: '6px' }}></div>
                <Card.Body className="p-4">
                  <Row className="align-items-center g-4">
                    <Col md="auto">
                      <div className="bg-primary bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center p-4" style={{ width: '100px', height: '100px' }}>
                        <Building size={48} className="text-primary" />
                      </div>
                    </Col>
                    <Col md={7}>
                      <div>
                        <div className="d-flex align-items-center gap-2 mb-2 flex-wrap">
                          <h2 className="mb-0">{contribuable.nom_contribuable?.toLocaleUpperCase('fr-FR')}</h2>
                          <Badge bg="success" className="d-flex align-items-center gap-1 px-3 py-2"><CheckCircle size={12} /> Actif</Badge>
                        </div>
                        <p className="text-muted mb-2"><Tag className="me-2" />ID Contribuable: <strong className="text-primary">{contribuable.contribuable_id}</strong></p>
                        <div className="d-flex flex-wrap gap-2 mb-3">
                          <div className="bg-light rounded-pill px-3 py-2"><PhoneFill className="text-primary me-2" size={14} />{contribuable.telephone}</div>
                          <div className="bg-light rounded-pill px-3 py-2"><EnvelopeFill className="text-primary me-2" size={14} />{contribuable.email || "Non spécifié"}</div>
                          <div className="d-flex gap-2">
                            <div className="bg-light rounded-pill px-3 py-2"><CalendarCheck className="text-primary me-2" size={14} />Enregistré le {formatDate(contribuable.created_at)}</div>
                            {contribuable.created_by_user && (
                              <div className="bg-light rounded-pill px-3 py-2 fw-bold">
                                <PersonFill className="text-primary me-2" size={14} />
                                Par : {contribuable.created_by_user.admin_fname} {contribuable.created_by_user.admin_lname}
                                {contribuable.created_by_user.matricule_interne && ` (${contribuable.created_by_user.matricule_interne})`}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="d-flex flex-wrap align-items-center gap-2">
                          <Badge bg="primary" className="d-flex align-items-center gap-1 px-3 py-2">
                            <Building size={12} /> {mainActivityName || 'Activité principale'}
                          </Badge>
                          {subAccounts && subAccounts.length > 0 && (
                            <>
                              {getPaginatedSubAccounts().paginated.map(sub => (
                                <Badge key={sub.contribuable_id} bg="secondary" className="d-flex align-items-center gap-1 px-3 py-2">
                                  <Briefcase size={12} /> {sub.activite_nom}
                                </Badge>
                              ))}
                              {subAccounts.length > subAccountsPerPage && (
                                <div className="ms-2">
                                  <Form.Select size="sm" value={subAccountsPerPage}
                                    onChange={(e) => { setSubAccountsPerPage(Number(e.target.value)); setSubAccountsPage(1); }}
                                    style={{ width: '70px', fontSize: '12px' }}>
                                    <option value={3}>3</option><option value={6}>6</option>
                                    <option value={9}>9</option><option value={12}>12</option>
                                  </Form.Select>
                                </div>
                              )}
                              {getPaginatedSubAccounts().totalPages > 1 && (
                                <div className="ms-2 d-flex align-items-center">
                                  <Button variant="link" size="sm" className="p-0 me-1 text-decoration-none"
                                    onClick={() => setSubAccountsPage(p => Math.max(1, p - 1))}
                                    disabled={subAccountsPage === 1} style={{ fontSize: '12px' }}>◀</Button>
                                  <span className="small text-muted mx-1">{subAccountsPage}/{getPaginatedSubAccounts().totalPages}</span>
                                  <Button variant="link" size="sm" className="p-0 ms-1 text-decoration-none"
                                    onClick={() => setSubAccountsPage(p => Math.min(getPaginatedSubAccounts().totalPages, p + 1))}
                                    disabled={subAccountsPage === getPaginatedSubAccounts().totalPages} style={{ fontSize: '12px' }}>▶</Button>
                                </div>
                              )}
                            </>
                          )}
                          <Badge bg="light" text="dark" className="d-flex align-items-center gap-1 px-3 py-2">
                            <Layers size={12} /> Total: {(subAccounts?.length || 0) + 1} activité(s)
                          </Badge>
                        </div>
                        {localiteInfo && localiteInfo.adresseComplete && (
                          <div className="mt-3 pt-2 border-top">
                            <small className="text-muted d-flex align-items-center gap-1">
                              <GeoAlt size={12} /> Adresse: {localiteInfo.adresseComplete}
                            </small>
                          </div>
                        )}
                      </div>
                    </Col>
                    <Col md={3}>
                      <div className="text-center">
                        <div className="position-relative d-inline-block">
                          <div className="progress-circle mx-auto" style={{ width: '120px', height: '120px' }}>
                            <div className="progress-circle-value" style={{ background: `conic-gradient(#0d6efd ${stats?.tauxRecouvrement || 0}%, #e9ecef ${stats?.tauxRecouvrement || 0}%)` }}>
                              <div className="progress-circle-inner">
                                <span className="h4 fw-bold">{Math.round(stats?.tauxRecouvrement || 0)}%</span>
                              </div>
                            </div>
                          </div>
                          <p className="mt-2 mb-0 text-muted">Taux de recouvrement</p>
                          <small className="text-muted">{formatCurrency(stats?.totalPaye || 0)} / {formatCurrency(stats?.totalInitial || 0)}</small>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* Statistiques par activité */}
              {Object.keys(activityStats).length > 0 && dataLoaded && (
                <Row className="mb-4 g-3">
                  <Col md={12}>
                    <Card className="border-0 shadow-sm">
                      <Card.Body className="p-3">
                        <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                          <div className="d-flex align-items-center gap-2">
                            <BarChart className="text-primary" />
                            <strong>Résumé par activité:</strong>
                            <Badge bg="secondary" className="ms-2">{getPaginatedActivityStats().totalItems} activité(s)</Badge>
                          </div>
                          <div className="d-flex align-items-center gap-2">
                            <span className="text-muted small">Activités par page:</span>
                            <Form.Select size="sm" value={activityStatsPerPage}
                              onChange={(e) => { setActivityStatsPerPage(Number(e.target.value)); setActivityStatsPage(1); }}
                              style={{ width: '70px' }}>
                              <option value={2}>2</option><option value={4}>4</option>
                              <option value={6}>6</option><option value={10}>10</option>
                              <option value={20}>20</option><option value={50}>50</option>
                            </Form.Select>
                          </div>
                        </div>
                        <Row className="g-3">
                          {getPaginatedActivityStats().paginated.map((stat, idx) => {
                            let accountInfo = null;
                            let isMain = false;
                            if (contribuable && String(stat.activityId) === String(contribuable.contribuable_id)) {
                              isMain = true;
                              accountInfo = {
                                contribuable_id: contribuable.contribuable_id,
                                activite_contribuable: contribuable.activite_contribuable,
                                nom: contribuable.nom_contribuable
                              };
                            } else {
                              const found = subAccounts.find(sub => String(sub.contribuable_id) === String(stat.activityId));
                              if (found) accountInfo = {
                                contribuable_id: found.contribuable_id,
                                activite_contribuable: found.activite_contribuable,
                                nom: found.nom_contribuable
                              };
                            }
                            return (
                              <Col key={idx} lg={4} md={6} sm={12}>
                                <div className="rounded p-3 h-100" style={{ background: '#f8f9fa', border: '1px solid #e9ecef' }}>
                                  <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-2">
                                    <div className="d-flex align-items-center gap-2">
                                      <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-stat-name">{stat.name}</Tooltip>}>
                                        <strong className="fs-6">{stat.name.length > 23 ? `${stat.name.substring(0, 23)}...` : stat.name}</strong>
                                      </OverlayTrigger>
                                      {isMain && <Badge bg="primary">Principale</Badge>}
                                      {!isMain && <Badge bg="secondary">Secondaire</Badge>}
                                    </div>
                                    {accountInfo && (
                                      <Button variant="outline-warning" size="sm"
                                        onClick={() => openModifyActivityModal({
                                          contribuable_id: accountInfo.contribuable_id,
                                          activite_contribuable: accountInfo.activite_contribuable,
                                          nom: accountInfo.nom,
                                          currentActivityName: stat.name
                                        })}
                                        title="Modifier l'activité"
                                        disabled={loadingModalOpen}>
                                        {loadingModalOpen ? <Spinner animation="border" size="sm" /> : <Pencil size={14} />}
                                      </Button>
                                    )}
                                  </div>
                                  <div className="d-flex gap-4 flex-wrap small">
                                    <div><span className="text-muted">Total:</span>{' '}<strong className="text-primary">{formatCurrency(stat.totalMontant)}</strong></div>
                                    <div><span className="text-muted">Payé:</span>{' '}<strong className="text-success">{formatCurrency(stat.totalPaye)}</strong></div>
                                    <div><span className="text-muted">Reste:</span>{' '}<strong className="text-danger">{formatCurrency(stat.totalRestant)}</strong></div>
                                    <div><span className="text-muted">Taxes:</span>{' '}<strong>{stat.taxCount}</strong></div>
                                  </div>
                                </div>
                              </Col>
                            );
                          })}
                        </Row>
                        {getPaginatedActivityStats().totalPages > 1 && (
                          <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                            <div className="text-muted small">Page {activityStatsPage} sur {getPaginatedActivityStats().totalPages}</div>
                            <Pagination size="sm" className="mb-0">
                              <Pagination.Prev disabled={activityStatsPage === 1} onClick={() => setActivityStatsPage(p => Math.max(1, p - 1))} />
                              {[...Array(Math.min(5, getPaginatedActivityStats().totalPages))].map((_, i) => (
                                <Pagination.Item key={i + 1} active={i + 1 === activityStatsPage} onClick={() => setActivityStatsPage(i + 1)}>{i + 1}</Pagination.Item>
                              ))}
                              <Pagination.Next disabled={activityStatsPage === getPaginatedActivityStats().totalPages} onClick={() => setActivityStatsPage(p => Math.min(getPaginatedActivityStats().totalPages, p + 1))} />
                            </Pagination>
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              )}

              {/* ✅ Cartes de statistiques (UTILISENT LES STATS GLOBALES DE L'API) */}
              <Row className="mb-4 g-4">
                <Col lg={3} md={6}>
                  <Card className="border-0 shadow-lg overflow-hidden" style={{ background: 'linear-gradient(135deg, #6c757d 0%, #495057 100%)', color: 'white' }}>
                    <Card.Body className="position-relative">
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <h6 className="text-uppercase mb-1 opacity-75">En attente</h6>
                          <h4 className="mb-0">{formatCurrency(echeanceStats.en_attente.total)}</h4>
                          <div className="mt-2">
                            <Badge bg="white" text="dark">
                              {echeanceStats.en_attente.count.toLocaleString('fr-FR')} échéance(s)
                            </Badge>
                          </div>
                        </div>
                        <div className="icon-statistic"><HourglassSplit size={40} /></div>
                      </div>
                      <div className="statistic-wave"></div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={3} md={6}>
                  <Card className="border-0 shadow-lg overflow-hidden" style={{ background: 'linear-gradient(135deg, #ffc107 0%, #d39e00 100%)', color: 'white' }}>
                    <Card.Body className="position-relative">
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <h6 className="text-uppercase mb-1 opacity-75">Partielles</h6>
                          <h4 className="mb-0">{formatCurrency(echeanceStats.partial.total)}</h4>
                          <div className="mt-2">
                            <Badge bg="white" text="dark">
                              {echeanceStats.partial.count.toLocaleString('fr-FR')} échéance(s)
                            </Badge>
                          </div>
                        </div>
                        <div className="icon-statistic"><Percent size={40} /></div>
                      </div>
                      <div className="statistic-wave"></div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={3} md={6}>
                  <Card className="border-0 shadow-lg overflow-hidden" style={{ background: 'linear-gradient(135deg, #198754 0%, #0d5c3a 100%)', color: 'white' }}>
                    <Card.Body className="position-relative">
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <h6 className="text-uppercase mb-1 opacity-75">Soldées</h6>
                          <h4 className="mb-0">{formatCurrency(echeanceStats.completed.total)}</h4>
                          <div className="mt-2">
                            <Badge bg="white" text="dark">
                              {echeanceStats.completed.count.toLocaleString('fr-FR')} échéance(s)
                            </Badge>
                          </div>
                        </div>
                        <div className="icon-statistic"><CheckCircle size={40} /></div>
                      </div>
                      <div className="statistic-wave"></div>
                    </Card.Body>
                  </Card>
                </Col>
                <Col lg={3} md={6}>
                  <Card className="border-0 shadow-lg overflow-hidden" style={{ background: 'linear-gradient(135deg, #0d6efd 0%, #0a58ca 100%)', color: 'white' }}>
                    <Card.Body className="position-relative">
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <h6 className="text-uppercase mb-1 opacity-75">Total initial</h6>
                          <h4 className="mb-0">{formatCurrency(globalStats.total_initial)}</h4>
                          <div className="mt-2">
                            <Badge bg="white" text="dark">
                              {parseInt(globalStats.total_echeances || 0).toLocaleString('fr-FR')} échéance(s)
                            </Badge>
                          </div>
                        </div>
                        <div className="icon-statistic"><Calculator size={40} /></div>
                      </div>
                      <div className="statistic-wave"></div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              {/* TABS */}
              <Card className="border-0 shadow-lg">
                <Card.Body className="p-0">
                  <Tabs activeKey={activeTab} onSelect={(k) => setActiveTab(k)} className="custom-tabs" fill>
                    {/* Onglet Vue d'ensemble */}
                    <Tab eventKey="overview" title={<div className="d-flex align-items-center justify-content-center gap-2 py-2"><PieChart size={18} /><span>Vue d'ensemble</span></div>}>
                      <div className="p-4">
                        <Row className="g-4">
                          <Col md={6}>
                            <Card className="border-0 shadow-sm h-100">
                              <Card.Body>
                                <h6 className="mb-3 d-flex align-items-center"><Receipt className="me-2 text-primary" />Répartition des taxes par activité</h6>
                                {Object.entries(activityStats).map(([key, stat], idx) => {
                                  const percentage = stats?.totalInitial > 0 ? (stat.totalMontant / stats.totalInitial) * 100 : 0;
                                  return (
                                    <div key={idx} className="mb-3">
                                      <div className="d-flex justify-content-between mb-1">
                                        <span>{stat.name}</span><span className="fw-bold">{formatCurrency(stat.totalMontant)}</span>
                                      </div>
                                      <ProgressBar now={percentage} variant={key === 'main' ? "primary" : "info"} style={{ height: '8px' }} />
                                      <small className="text-muted">{stat.taxCount} taxe(s) • {percentage.toFixed(1)}% du total</small>
                                    </div>
                                  );
                                })}
                                <div className="mt-3 pt-3 border-top">
                                  <div className="d-flex justify-content-between"><span>Total général</span><span className="fw-bold">{formatCurrency(totalGeneral)}</span></div>
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                          <Col md={6}>
                            <Card className="border-0 shadow-sm h-100">
                              <Card.Body>
                                <h6 className="mb-3 d-flex align-items-center"><ClockHistory className="me-2 text-primary" />Statut des échéances</h6>
                                <div className="mb-3">
                                  <div className="d-flex justify-content-between mb-1">
                                    <span>Soldées</span>
                                    <span>{echeanceStats.completed.count.toLocaleString('fr-FR')} / {parseInt(globalStats.total_echeances || 0).toLocaleString('fr-FR')}</span>
                                  </div>
                                  <ProgressBar now={(echeanceStats.completed.count / (parseInt(globalStats.total_echeances) || 1)) * 100} variant="success" style={{ height: '8px' }} />
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex justify-content-between mb-1">
                                    <span>Partielles</span>
                                    <span>{echeanceStats.partial.count.toLocaleString('fr-FR')} / {parseInt(globalStats.total_echeances || 0).toLocaleString('fr-FR')}</span>
                                  </div>
                                  <ProgressBar now={(echeanceStats.partial.count / (parseInt(globalStats.total_echeances) || 1)) * 100} variant="warning" style={{ height: '8px' }} />
                                </div>
                                <div className="mb-3">
                                  <div className="d-flex justify-content-between mb-1">
                                    <span>En attente</span>
                                    <span>{echeanceStats.en_attente.count.toLocaleString('fr-FR')} / {parseInt(globalStats.total_echeances || 0).toLocaleString('fr-FR')}</span>
                                  </div>
                                  <ProgressBar now={(echeanceStats.en_attente.count / (parseInt(globalStats.total_echeances) || 1)) * 100} variant="secondary" style={{ height: '8px' }} />
                                </div>
                              </Card.Body>
                            </Card>
                          </Col>
                          <Col md={12}>
                            <Card className="border-0 shadow-sm">
                              <Card.Body>
                                <h6 className="mb-3 d-flex align-items-center"><Activity className="me-2 text-primary" />Activités récentes</h6>
                                {loadingActivity ? <div className="text-center py-3"><Spinner animation="border" size="sm" /></div> : filteredActivity.slice(0, 5).map((act, idx) => (
                                  <div key={idx} className="d-flex align-items-center gap-3 p-2 border-bottom">
                                    <div className={`bg-${act.color} bg-opacity-10 rounded-circle p-2`}>{act.type === 'paiement' ? <Cash size={16} className={`text-${act.color}`} /> : <ClockHistory size={16} className={`text-${act.color}`} />}</div>
                                    <div className="flex-grow-1"><div className="fw-medium">{act.title}</div><small className="text-muted">{act.description}</small></div>
                                    <small className="text-muted">{formatRelativeTime(act.date)}</small>
                                  </div>
                                ))}
                              </Card.Body>
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    </Tab>

                    {/* Onglet Taxes */}
                    <Tab eventKey="taxes" title={<div className="d-flex align-items-center justify-content-center gap-2 py-2"><Receipt size={18} /><span>Taxes</span></div>}>
                      <div className="p-4">
                        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                          <div><h5 className="mb-0">Gestion des taxes</h5><small className="text-muted">{filteredTaxes.length} taxe(s) au total</small></div>
                        </div>

                        <Card className="border-0 shadow-sm mb-4">
                          <Card.Body>
                            <Row className="g-3">
                              <Col md={4}><InputGroup><InputGroup.Text><Search /></InputGroup.Text><Form.Control placeholder="Rechercher une taxe..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} /></InputGroup></Col>
                              <Col md={3}><Form.Select value={selectedStatus} onChange={(e) => setSelectedStatus(e.target.value)}><option value="all">Tous les statuts</option><option value="pending">En attente</option><option value="paid">Payée</option><option value="partial">Partielle</option><option value="overdue">Impayée</option></Form.Select></Col>
                              <Col md={3}>
                                <Form.Select size="md" value={taxActivityFilter} onChange={(e) => setTaxActivityFilter(e.target.value)} style={{ width: '250px' }}>
                                  <option value="all">Toutes les activités</option>
                                  {[{ contribuable_id: contribuable?.contribuable_id, activite_nom: mainActivityName }, ...subAccounts].map(act => (
                                    <option key={act.contribuable_id} value={act.contribuable_id}>{act.activite_nom}</option>
                                  ))}
                                </Form.Select>
                              </Col>
                              <Col md={2}><Button variant="light" className="w-100" onClick={() => { setSearchTerm(""); setSelectedStatus("all"); }}><Filter className="me-1" />Réinitialiser</Button></Col>
                            </Row>
                          </Card.Body>
                        </Card>

                        <div className="table-responsive">
                          <Table hover className="table-custom">
                            <thead className="table-light">
                              <tr>
                                <th onClick={() => requestSort('type')} className="cursor-pointer">Type de taxe</th>
                                <th>Activité</th>
                                <th onClick={() => requestSort('annee')} className="cursor-pointer">Année</th>
                                <th>Mont./Éch.</th>
                                <th onClick={() => requestSort('montant')} className="cursor-pointer">Total</th>
                                <th onClick={() => requestSort('montantPaye')} className="cursor-pointer">Payé</th>
                                <th onClick={() => requestSort('montantRestant')} className="cursor-pointer">Reste</th>
                                <th>Progression</th>
                                <th>Statut</th>
                                <th className="text-end">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filterLoading || loadingDetails ? (
                                <tr><td colSpan="10" className="text-center py-5"><Spinner animation="border" variant="primary" size="sm" className="me-2" /> Chargement des taxes...</td></tr>
                              ) : filteredTaxes.length === 0 ? (
                                <tr><td colSpan="10" className="text-center py-4"><Receipt size={48} className="text-muted opacity-50 mb-2" /><p>Aucune taxe trouvée</p></td></tr>
                              ) : (
                                (() => {
                                  const grouped = filteredTaxes.reduce((acc, tax) => {
                                    const key = tax.activityId || 'main';
                                    if (!acc[key]) acc[key] = { name: tax.activityName || mainActivityName || 'Activité', taxes: [], id_export: tax.activite_contribuable || null };
                                    acc[key].taxes.push(tax);
                                    return acc;
                                  }, {});
                                  return Object.entries(grouped).map(([activityId, group]) => (
                                    <React.Fragment key={activityId}>
                                      <tr className="table-active">
                                        <td colSpan="10" className="py-2">
                                          <div className="d-flex align-items-center">
                                            <Badge bg="info" className="me-2 p-2"><Briefcase size={14} /></Badge>
                                            <div className="contribuable-name-wrapper" data-fullname={group.name}>
                                              <div className="contribuable-name" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                <strong>{group.name}</strong>
                                              </div>
                                            </div>
                                            <Badge bg="light" text="dark" className="ms-2">{group.taxes.length} taxe(s)</Badge>
                                            {activityId === contribuable?.contribuable_id?.toString() && (<Badge bg="primary" className="ms-2">Activité principale</Badge>)}
                                          </div>
                                        </td>
                                      </tr>
                                      {group.taxes.map((tax, idx) => (
                                        <tr key={idx} className={tax.realStatus === 'overdue' ? 'table-danger' : ''}>
                                          <td style={{ paddingLeft: '40px' }}>
                                            <div className="d-flex align-items-center">
                                              <div className={`bg-${tax.couleur} bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center me-2`} style={{ width: '28px', height: '28px' }}>
                                                <Receipt size={14} className={`text-${tax.couleur}`} />
                                              </div>
                                              <div>
                                                <div className="fw-medium">{tax.type}</div>
                                                <small className="text-muted">ID: {tax.taxe_id} • {tax.echeancesCount} échéance(s)</small>
                                              </div>
                                            </div>
                                          </td>
                                          <td>
                                            <Badge className="px-2 py-1">
                                              <div className="contribuable-name-wrapper" data-fullname={group.name}>
                                                <div className="contribuable-name1" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                                  <strong>{group.name}</strong>
                                                </div>
                                              </div>
                                            </Badge>
                                          </td>
                                          <td><Badge bg="light" text="dark">{tax.annee}</Badge></td>
                                          <td className="text-primary">
                                            <strong>{formatCurrency(tax.montant_par_echeance)}</strong>
                                            <Button variant="link" size="sm" className="p-0 ms-2 text-primary"
                                              onClick={() => {
                                                setSelectedTax(tax);
                                                setEditTaxAmount(tax.montant_par_echeance);
                                                setEditTaxFrequency(normalizeFrequency(tax.frequence));
                                                setEditTaxStartDate(new Date().toISOString().split('T')[0]);
                                                setShowEditTaxModal(true);
                                              }}
                                              title="Modifier le montant par échéance"><Pencil size={12} /></Button>
                                          </td>
                                          <td>{formatCurrency(tax.montant)}</td>
                                          <td className="text-success">{formatCurrency(tax.montantPaye)}</td>
                                          <td className="text-danger">{formatCurrency(tax.montantRestant)}</td>
                                          <td>
                                            <div className="d-flex align-items-center">
                                              <div className="flex-grow-1 me-2"><ProgressBar now={tax.pourcentagePaiement} variant={tax.pourcentagePaiement >= 100 ? 'success' : tax.pourcentagePaiement >= 50 ? 'warning' : 'danger'} style={{ height: '6px' }} /></div>
                                              <small>{Math.round(tax.pourcentagePaiement)}%</small>
                                            </div>
                                          </td>
                                          <td>{getTaxStatusBadge(tax)}</td>
                                          <td className="text-end">
                                            <Dropdown>
                                              <Dropdown.Toggle variant="outline-secondary" size="sm"><ThreeDotsVertical size={12} /></Dropdown.Toggle>
                                              <Dropdown.Menu align="end">
                                                <Dropdown.Item onClick={() => {
                                                  let activityIdValue = null;
                                                  if (tax.activite_contribuable) activityIdValue = tax.activite_contribuable;
                                                  else if (tax._original && tax._original.activite_contribuable) activityIdValue = tax._original.activite_contribuable;
                                                  else if (subAccounts.length > 0) {
                                                    const foundSub = subAccounts.find(s => s.contribuable_id === tax.activityId);
                                                    if (foundSub && foundSub.activite_contribuable) activityIdValue = foundSub.activite_contribuable;
                                                  }
                                                  const url = `/echeances-tax/${tax.taxe_id}/${contribuable.contribuable_id}${activityIdValue ? `/${activityIdValue}` : ''}`;
                                                  navigate(url);
                                                }}>
                                                  <Eye size={12} className="me-1" /> Voir détails
                                                </Dropdown.Item>
                                                <Dropdown.Divider />
                                                <Dropdown.Item className="text-danger" onClick={() => { setTaxToRemove(tax); setShowRemoveTaxModal(true); }}>
                                                  <Trash size={12} className="me-1" /> Mettre à zéro
                                                </Dropdown.Item>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </td>
                                        </tr>
                                      ))}
                                    </React.Fragment>
                                  ));
                                })()
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    </Tab>

                    {/* Onglet Échéances */}
                    <Tab eventKey="echeances" title={<div className="d-flex align-items-center justify-content-center gap-2 py-2"><Calendar size={18} /><span>Échéances</span></div>}>
                      <div className="p-4">
                        <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                          <div>
                            <h5 className="mb-0">Détails des échéances</h5>
                            <small className="text-muted">{echeances.length} échéance(s) affichée(s) / {echeanceTotalItems.toLocaleString('fr-FR')} total</small>
                          </div>
                          <div className="d-flex gap-2 flex-wrap">
                            <InputGroup style={{ width: '250px' }}>
                              <InputGroup.Text><Search size={14} /></InputGroup.Text>
                              <Form.Control type="text" placeholder="Rechercher..." value={echeanceSearchTerm} onChange={(e) => handleEcheanceSearch(e.target.value)} size="sm" />
                            </InputGroup>
                            <Form.Select size="sm" value={echeanceActivityFilter} onChange={(e) => { setEcheanceActivityFilter(e.target.value); setEcheanceCurrentPage(1); }} style={{ width: '200px' }}>
                              <option value="all">Toutes les activités</option>
                              <option value={contribuable?.contribuable_id}>{mainActivityName || 'Activité principale'}</option>
                              {subAccounts.map(sub => (<option key={sub.contribuable_id} value={sub.contribuable_id}>{sub.activite_nom}</option>))}
                            </Form.Select>
                            <Form.Select size="sm" value={echeanceItemsPerPage} onChange={(e) => { setEcheanceItemsPerPage(Number(e.target.value)); setEcheanceCurrentPage(1); }} style={{ width: '100px' }}>
                              <option value="5">5 / page</option><option value="10">10 / page</option>
                              <option value="25">25 / page</option><option value="50">50 / page</option>
                            </Form.Select>
                            <Button size="sm" variant="outline-info" onClick={checkEcheancesStatus} disabled={regeneratingEcheances} title="Vérifier l'état">
                              {regeneratingEcheances ? <Spinner animation="border" size="sm" className="me-1" /> : <Eye size={14} className="me-1" />}Vérifier
                            </Button>
                            <Dropdown>
                              <Dropdown.Toggle size="sm" variant="outline-warning" disabled={regeneratingEcheances}>
                                {regeneratingEcheances ? <Spinner animation="border" size="sm" className="me-1" /> : <ArrowRepeat size={14} className="me-1" />}Régénérer
                              </Dropdown.Toggle>
                              <Dropdown.Menu align="end">
                                <Dropdown.Item onClick={() => { setRegenerateType('missing'); setShowRegenerateConfirm(true); }}>
                                  <PlusCircle size={14} className="me-2 text-success" />Régénérer les échéances manquantes
                                </Dropdown.Item>
                                <Dropdown.Divider />
                                <Dropdown.Item onClick={() => { setRegenerateType('all'); setShowRegenerateConfirm(true); }} className="text-danger">
                                  <Trash size={14} className="me-2 text-danger" />Régénérer TOUTES les échéances
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <Table hover className="table-custom">
                            <thead className="table-light">
                              <tr>
                                <th>Activité</th><th>Période</th><th>Date échéance</th><th>Taxe</th>
                                <th>Montant initial</th><th>Montant payé</th><th>Reste</th><th>Statut</th><th className="text-end">Actions</th>
                              </tr>
                            </thead>
                            <tbody>
                              {echeanceLoading ? (
                                <tr><td colSpan="9" className="text-center py-4"><Spinner animation="border" size="sm" className="me-2" />Chargement des échéances...</td></tr>
                              ) : getFilteredAndPaginatedEcheances().paginated.length === 0 ?
                                <tr><td colSpan="9" className="text-center py-4">Aucune échéance trouvée</td></tr> :
                                getFilteredAndPaginatedEcheances().paginated.map((echeance, idx) => {
                                  const montantInitial = parseFloat(echeance.montant_initial || echeance.montant_attendu || 0);
                                  const montantPaye = parseFloat(echeance.montant_paye || 0);
                                  const dueDate = new Date(echeance.date_echeance);
                                  const periodLabel = `${dueDate.toLocaleString('fr-FR', { month: 'long' })} ${dueDate.getFullYear()}`;
                                  const isOverdue = echeance.statut === 'en_attente' && dueDate < new Date();
                                  const isPaid = echeance.statut === 'completed' || montantPaye >= montantInitial;
                                  return (
                                    <tr key={echeance.id || idx} className={isOverdue ? 'table-danger' : ''}>
                                      <td>
                                        <div className="contribuable-name-wrapper" data-fullname={echeance._activityName || mainActivityName || 'Activité principale'}>
                                          <div className="contribuable-name1" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                            <strong>{echeance._activityName || mainActivityName || 'Activité principale'}</strong>
                                          </div>
                                        </div>
                                      </td>
                                      <td><strong>{periodLabel}</strong>{isOverdue && <Badge bg="danger" className="ms-2" style={{ fontSize: '9px' }}>En retard</Badge>}</td>
                                      <td>{formatDate(echeance.date_echeance)}</td>
                                      <td><small>{echeance.taxe?.titre || 'Taxe'}</small></td>
                                      <td><strong>{formatCurrency(montantInitial)}</strong></td>
                                      <td className="text-success">{formatCurrency(montantPaye)}</td>
                                      <td className="text-danger">{formatCurrency(montantInitial - montantPaye)}</td>
                                      <td>{getEcheanceStatusBadge(echeance.statut)}</td>
                                      <td className="text-end">
                                        <div className="d-flex gap-2 justify-content-end">
                                          {!isPaid && (
                                            <Button variant="success" size="sm" onClick={() => navigate(`/collecte/${echeance.taxe_id}/${contribuable.contribuable_id}/${echeance.echeance_id}`)} className="d-flex align-items-center gap-1">
                                              <Cash size={14} /> Collecter
                                            </Button>
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  );
                                })
                              }
                            </tbody>
                          </Table>
                        </div>

                        {/* ✅ Bouton CHARGER PLUS d'échéances (pagination serveur) */}
                        {serverEcheancesPage < serverEcheancesLastPage && (
                          <div className="d-flex justify-content-center py-3 border-top mt-2">
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={loadMoreEcheances}
                              disabled={loadingMoreEcheances}
                            >
                              {loadingMoreEcheances ? (
                                <><Spinner animation="border" size="sm" className="me-2" />Chargement...</>
                              ) : (
                                <><PlusCircle size={14} className="me-2" />Charger plus ({echeances.length.toLocaleString('fr-FR')} / {echeanceTotalItems.toLocaleString('fr-FR')})</>
                              )}
                            </Button>
                          </div>
                        )}

                        {/* Pagination locale (affichage des échéances chargées) */}
                        {getFilteredAndPaginatedEcheances().totalPages > 1 && (
                          <div className="d-flex justify-content-between align-items-center mt-3 pt-2 border-top">
                            <div className="text-muted small">
                              Affichage de {((echeanceCurrentPage - 1) * echeanceItemsPerPage) + 1} à {Math.min(echeanceCurrentPage * echeanceItemsPerPage, getFilteredAndPaginatedEcheances().totalItems)} sur {getFilteredAndPaginatedEcheances().totalItems.toLocaleString('fr-FR')} échéances chargées
                            </div>
                            <Pagination size="sm" className="mb-0">
                              <Pagination.Prev disabled={echeanceCurrentPage === 1} onClick={() => setEcheanceCurrentPage(p => Math.max(1, p - 1))} />
                              {[...Array(Math.min(5, getFilteredAndPaginatedEcheances().totalPages))].map((_, i) => (
                                <Pagination.Item key={i + 1} active={i + 1 === echeanceCurrentPage} onClick={() => setEcheanceCurrentPage(i + 1)}>{i + 1}</Pagination.Item>
                              ))}
                              <Pagination.Next disabled={echeanceCurrentPage === getFilteredAndPaginatedEcheances().totalPages} onClick={() => setEcheanceCurrentPage(p => Math.min(getFilteredAndPaginatedEcheances().totalPages, p + 1))} />
                            </Pagination>
                          </div>
                        )}
                      </div>
                    </Tab>

                    {/* Onglet Informations */}
                    <Tab eventKey="informations" title={<div className="d-flex align-items-center justify-content-center gap-2 py-2"><Building size={18} /><span>Informations</span></div>}>
                      <div className="p-4">
                        <Row>
                          <Col md={6}>
                            <Card className="border-0 shadow-sm mb-4">
                              <Card.Body>
                                <h6 className="mb-3"><Building className="me-2 text-primary" />Identité & Statut</h6>
                                <ListGroup variant="flush">
                                  <ListGroup.Item className="d-flex justify-content-between px-0"><span>ID Contribuable</span><code>{contribuable.contribuable_id}</code></ListGroup.Item>
                                  <ListGroup.Item className="d-flex justify-content-between px-0"><span>Forme juridique</span><Badge bg="info">{contribuable.forme_juridique || "Non spécifiée"}</Badge></ListGroup.Item>
                                  <ListGroup.Item className="d-flex justify-content-between px-0"><span>Activité principale</span><span className="fw-medium">{mainActivityName || "Non spécifiée"}</span></ListGroup.Item>
                                  <ListGroup.Item className="d-flex justify-content-between px-0"><span>Inscription</span><span>{formatDateTime(contribuable.created_at)}</span></ListGroup.Item>
                                </ListGroup>
                              </Card.Body>
                            </Card>
                            {subAccounts.length > 0 && (
                              <Card className="border-0 shadow-sm">
                                <Card.Body>
                                  <h6 className="mb-3"><Briefcase className="me-2 text-primary" />Activités secondaires</h6>
                                  <ListGroup variant="flush">
                                    {subAccounts.map(sub => (
                                      <ListGroup.Item key={sub.contribuable_id} className="d-flex justify-content-between align-items-center px-0 py-3 border-bottom">
                                        <div><div className="fw-medium">{sub.nom_contribuable}</div><small className="text-muted">ID: {sub.contribuable_id}</small></div>
                                        <Badge bg="info" className="px-3 py-2">{sub.activite_nom}</Badge>
                                      </ListGroup.Item>
                                    ))}
                                  </ListGroup>
                                </Card.Body>
                              </Card>
                            )}
                          </Col>
                          <Col md={6}>
                            <Card className="border-0 shadow-sm mb-4">
                              <Card.Body>
                                <h6 className="mb-3"><GeoAlt className="me-2 text-primary" />Contact & Localisation</h6>
                                <ListGroup variant="flush">
                                  <ListGroup.Item className="d-flex align-items-start px-0"><Phone className="text-primary me-2" size={14} /><div><h6 className="mb-0 small">Téléphone</h6><p className="mb-0">{contribuable.telephone}</p></div></ListGroup.Item>
                                  <ListGroup.Item className="d-flex align-items-start px-0"><Envelope className="text-primary me-2" size={14} /><div><h6 className="mb-0 small">Email</h6><p className="mb-0">{contribuable.email || "Non spécifié"}</p></div></ListGroup.Item>
                                  <ListGroup.Item className="d-flex align-items-start px-0"><GeoAlt className="text-primary me-2" size={14} /><div><h6 className="mb-0 small">Adresse</h6><p className="mb-0">{localiteInfo?.adresseComplete || contribuable.adresse || "Non spécifiée"}</p></div></ListGroup.Item>
                                </ListGroup>
                              </Card.Body>
                            </Card>
                          </Col>
                        </Row>
                      </div>
                    </Tab>

                    {/* Onglet Activité */}
                    <Tab eventKey="activite" title={<div className="d-flex align-items-center justify-content-center gap-2 py-2"><Activity size={18} /><span>Activité</span>{loadingActivity && <Spinner animation="border" size="sm" className="ms-1" />}</div>}>
                      <div className="p-4">
                        <div className="d-flex justify-content-between align-items-center mb-4">
                          <h5 className="mb-0">Journal d'activité</h5>
                          <div className="d-flex gap-2">
                            <Form.Select size="sm" value={activityFilter} onChange={(e) => setActivityFilter(e.target.value)} style={{ width: '150px' }}>
                              <option value="all">Toutes</option><option value="paiement">Paiements</option>
                              <option value="echeance">Échéances</option><option value="modification">Modifications</option>
                            </Form.Select>
                            <Button variant="outline-secondary" size="sm" onClick={refreshActivity}><ArrowRepeat size={14} /></Button>
                          </div>
                        </div>
                        {loadingActivity ? <div className="text-center py-5"><Spinner animation="border" variant="primary" /></div> :
                         activityData.length === 0 ? <div className="text-center py-5"><Activity size={48} className="text-muted opacity-50 mb-3" /><p>Aucune activité récente</p></div> :
                         <div className="timeline">{filteredActivity.map((activity, idx) => (
                           <div className="timeline-item" key={idx}>
                             <div className={`timeline-marker bg-${activity.color || 'primary'}`}></div>
                             <div className="timeline-content">
                               <div className="d-flex justify-content-between"><h6 className="mb-1">{activity.title}</h6><small className="text-muted">{formatRelativeTime(activity.date)}</small></div>
                               <p className="text-muted small mb-2">{activity.description}</p>
                               <div className="d-flex gap-2">{activity.badges?.map((b, i) => <Badge key={i} bg={b.bg}>{b.text}</Badge>)}</div>
                             </div>
                           </div>
                         ))}</div>}
                      </div>
                    </Tab>
                  </Tabs>
                </Card.Body>
              </Card>
            </>
          )}
        </div>
        <Footer />
      </div>

      {/* ==================== MODALS ==================== */}

      {/* Modal modification contribuable */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg" centered>
        <Modal.Header closeButton className="bg-primary text-white"><Modal.Title><Pencil className="me-2" /> Modifier le contribuable</Modal.Title></Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12}><Form.Group className="mb-3"><Form.Label>Nom</Form.Label><Form.Control type="text" value={editForm.nom_contribuable || ''} onChange={(e) => setEditForm({...editForm, nom_contribuable: e.target.value})} /></Form.Group></Col>
            <Col md={6}><Form.Group className="mb-3"><Form.Label>Téléphone</Form.Label><Form.Control type="tel" value={editForm.telephone || ''} onChange={(e) => setEditForm({...editForm, telephone: e.target.value})} /></Form.Group></Col>
            <Col md={6}><Form.Group className="mb-3"><Form.Label>Email</Form.Label><Form.Control type="email" value={editForm.email || ''} onChange={(e) => setEditForm({...editForm, email: e.target.value})} /></Form.Group></Col>
            <Col md={12}><Form.Group className="mb-3"><Form.Label>Adresse</Form.Label><Form.Control type="text" value={editForm.adresse || ''} onChange={(e) => setEditForm({...editForm, adresse: e.target.value})} /></Form.Group></Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowEditModal(false)}>Annuler</Button>
          <Button variant="primary" onClick={handleUpdateContribuable} disabled={updatingContact}>
            {updatingContact ? <><Spinner size="sm" className="me-2" />Enregistrement...</> : <><Check className="me-2" />Enregistrer</>}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal affecter taxes */}
      <Modal show={showAssignTaxModal} onShow={() => { fetchAvailableTaxes(); setSelectedTaxes([]); }} onHide={() => setShowAssignTaxModal(false)} size="lg" centered>
        <Modal.Header closeButton className="bg-primary text-white"><Modal.Title><Plus className="me-2" /> Affecter des taxes</Modal.Title></Modal.Header>
        <Modal.Body>
          <div className="alert alert-info mb-4"><Person className="me-2" />{contribuable?.nom_contribuable} (ID: {contribuable?.contribuable_id})</div>
          <h6 className="mb-3">Sélectionnez les taxes à affecter {selectedTaxes.length > 0 && <Badge bg="primary" className="ms-2">{selectedTaxes.length} sélectionnée(s)</Badge>}</h6>
          {loadingTaxes ? <div className="text-center py-4"><Spinner animation="border" variant="primary" /></div> :
           availableTaxes.length > 0 ?
            <div className="row g-2" style={{ maxHeight: '400px', overflowY: 'auto' }}>
              {availableTaxes.map(tax => (
                <Col md={6} key={tax.taxe_id}>
                  <Card className={`cursor-pointer ${selectedTaxes.includes(tax.taxe_id) ? 'border-primary bg-primary-subtle' : ''}`} onClick={() => handleTaxSelection(tax.taxe_id)}>
                    <Card.Body className="py-3">
                      <div className="d-flex align-items-center">
                        <Form.Check type="checkbox" checked={selectedTaxes.includes(tax.taxe_id)} onChange={() => handleTaxSelection(tax.taxe_id)} className="me-3" />
                        <div><h6 className="mb-1">{tax.titre}</h6><small className="text-muted">Code: {tax.taxe_id} | Fréquence: {tax.frequence}</small></div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </div> :
            <div className="text-center py-4"><CheckCircle size={48} className="text-success mb-3 opacity-50" /><p>Toutes les taxes ont déjà été affectées</p></div>
          }
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowAssignTaxModal(false)}>Annuler</Button>
          <Button variant="primary" onClick={handleAssignTaxes} disabled={selectedTaxes.length === 0 || assigningTaxes}>
            {assigningTaxes ? <><Spinner size="sm" className="me-2" />Affectation...</> : <><Plus className="me-2" />Affecter {selectedTaxes.length} taxe(s)</>}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal mise à zéro taxe */}
      <Modal show={showRemoveTaxModal} onHide={() => { setShowRemoveTaxModal(false); setRemoveTaxReason(""); }} size="md" centered>
        <Modal.Header closeButton className="bg-danger text-white"><Modal.Title><Trash className="me-2" /> Mettre à zéro une taxe</Modal.Title></Modal.Header>
        <Modal.Body>
          <div className="text-center mb-3"><ExclamationCircle size={48} className="text-warning" /></div>
          <h5 className="text-center">Confirmer la mise à zéro</h5>
          <div className="alert alert-warning"><ExclamationCircle className="me-2" /> Cette action est irréversible.</div>
          {taxToRemove && (
            <Card className="border shadow-sm mb-3">
              <Card.Body>
                <div className="d-flex align-items-center mb-3">
                  <div className={`bg-${taxToRemove.couleur} bg-opacity-10 rounded-circle p-2 me-3`}><Receipt size={20} className={`text-${taxToRemove.couleur}`} /></div>
                  <div><h6 className="mb-0">{taxToRemove.type}</h6><small>ID: {taxToRemove.taxe_id}</small></div>
                </div>
                <ListGroup variant="flush" className="small">
                  <ListGroup.Item className="d-flex justify-content-between px-0"><span>Montant:</span><strong>{formatCurrency(taxToRemove.montant)}</strong></ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between px-0"><span>Payé:</span><span className="text-success">{formatCurrency(taxToRemove.montantPaye)}</span></ListGroup.Item>
                  <ListGroup.Item className="d-flex justify-content-between px-0"><span>Reste:</span><span className="text-danger">{formatCurrency(taxToRemove.montantRestant)}</span></ListGroup.Item>
                </ListGroup>
              </Card.Body>
            </Card>
          )}
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">Raison de la mise à zéro <span className="text-danger">*</span></Form.Label>
            <Form.Control as="textarea" rows={3} value={removeTaxReason} onChange={(e) => setRemoveTaxReason(e.target.value)} placeholder="Ex: Paiement en espèces hors système..." required />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => { setShowRemoveTaxModal(false); setRemoveTaxReason(""); }}>Annuler</Button>
          <Button variant="danger" onClick={handleRemoveTax} disabled={removingTax || !removeTaxReason.trim()}>
            {removingTax ? <><Spinner size="sm" className="me-2" />Mise à zéro...</> : <><Trash className="me-2" />Confirmer</>}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal ajout activité */}
      <Modal show={showAddActivityModal} onHide={() => {
        setShowAddActivityModal(false);
        setSelectedActivityForAdd(null);
        setSelectedActivityTaxes([]);
        setActivityIdNat(""); setActivityRccm(""); setActivityNif("");
        setValidationErrors({}); setActivityAdresse(""); setActivityQuartierId("");
        setActivityQuartierInfo(null); setActivityCodePostal("");
      }} size="lg" centered>
        <Modal.Header closeButton className="bg-success text-white">
          <Modal.Title><PlusCircle className="me-2" /> Ajouter une activité secondaire</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{height:'550px',overflowY:'auto'}}>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label className="fw-medium">Activité économique <span className="text-danger">*</span></Form.Label>
              {loadingActivities ? <div className="text-center p-3 bg-light"><Spinner animation="border" size="sm" /></div> :
               availableActivities.length === 0 ?
                <Alert variant="warning" className="mb-0"><InfoCircle className="me-2" />Toutes les activités ont déjà été affectées.</Alert> :
                <Select options={availableActivities} value={selectedActivityForAdd}
                  onChange={(opt) => { setSelectedActivityForAdd(opt); if (opt) fetchActivityTaxesForAdd(opt.value); else setSelectedActivityTaxes([]); }}
                  isClearable isSearchable placeholder="Rechercher une activité non affectée..."
                  className="react-select-container"
                  styles={{ control: (base) => ({ ...base, backgroundColor: '#f8f9fa' }) }} />
              }
            </Form.Group>

            {selectedActivityForAdd && (
              <div className="mt-3">
                <Form.Label className="fw-medium"><Receipt className="me-1" />Taxes associées</Form.Label>
                {loadingActivityTaxes ? <div className="text-center py-3 bg-light"><Spinner animation="border" size="sm" /></div> :
                 selectedActivityTaxes.length > 0 ? (
                  <Card className="border shadow-sm">
                    <div className="table-responsive">
                      <Table hover size="sm" className="mb-0">
                        <thead className="table-light"><tr><th>Code</th><th>Intitulé</th><th>Montant</th><th>Fréquence</th></tr></thead>
                        <tbody>
                          {selectedActivityTaxes.map((tax, idx) => (
                            <tr key={idx}>
                              <td><Badge bg="secondary">{tax.taxe_id || tax.id}</Badge></td>
                              <td><strong>{tax.taxe_name || tax.type}</strong></td>
                              <td className="text-primary fw-bold">{formatCurrency(tax.default_amount || tax.montant || 0)}</td>
                              <td><Badge bg="info">
                                {tax.default_frequency === 'monthly' ? 'Mensuelle' :
                                 tax.default_frequency === 'quarterly' ? 'Trimestrielle' :
                                 tax.default_frequency === 'one_off' ? 'Unique' :
                                 tax.default_frequency === 'semiannual' ? 'Semestrielle' :
                                 tax.default_frequency === 'daily' ? 'Journalière' :
                                 tax.default_frequency === 'annual' ? 'Annuelle' : 'Mensuelle'}
                              </Badge></td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                    <div className="p-2 bg-light border-top"><small><InfoCircle size={12} className="me-1" />{selectedActivityTaxes.length} taxe(s) seront automatiquement appliquées</small></div>
                  </Card>
                ) : (
                  <div className="text-muted small p-3 border rounded bg-light text-center"><ExclamationCircle className="me-1" />Aucune taxe associée à cette activité</div>
                )}
              </div>
            )}

            <Card className="border-0 bg-light mb-3">
              <Card.Body>
                <h6 className="mb-3"><FileText className="me-2 text-primary" />Documents légaux (optionnels)</h6>
                <Row>
                  <Col md={4}>
                    <Form.Group className="mb-2">
                      <Form.Label><Key className="me-1" size={14} /> ID NAT</Form.Label>
                      <Form.Control type="text" value={activityIdNat} onChange={(e) => setActivityIdNat(e.target.value)} placeholder="Ex: NAT123456789" isInvalid={!!validationErrors.id_nat} />
                      <Form.Control.Feedback type="invalid">{validationErrors.id_nat?.[0]}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-2">
                      <Form.Label><FileText className="me-1" size={14} /> RCCM</Form.Label>
                      <Form.Control type="text" value={activityRccm} onChange={(e) => setActivityRccm(e.target.value)} placeholder="Ex: RC2024/001" isInvalid={!!validationErrors.rccm} />
                      <Form.Control.Feedback type="invalid">{validationErrors.rccm?.[0]}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-2">
                      <Form.Label><CreditCard2Front className="me-1" size={14} /> NIF</Form.Label>
                      <Form.Control type="text" value={activityNif} onChange={(e) => setActivityNif(e.target.value)} placeholder="Ex: 1234567890" isInvalid={!!validationErrors.nif} />
                      <Form.Control.Feedback type="invalid">{validationErrors.nif?.[0]}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>

            <Card className="border-0 bg-light mb-3">
              <Card.Body>
                <h6 className="mb-3"><GeoAlt className="me-2 text-primary" />Localisation (optionnelle)</h6>
                <Row className="mb-3">
                  <Col md={12}>
                    <Form.Group className="mb-2">
                      <Form.Label><GeoAlt className="me-1" size={14} /> Adresse</Form.Label>
                      <Form.Control type="text" value={activityAdresse} onChange={(e) => setActivityAdresse(e.target.value)} placeholder="Adresse complète (optionnel)" />
                      <Form.Text className="text-muted">Si non spécifié, l'adresse du compte principal sera utilisée</Form.Text>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md={8}>
                    <Form.Group className="mb-2">
                      <Form.Label><GeoAlt className="me-1" size={14} /> Localité</Form.Label>
                      <Select options={quartierOptionsForActivity} value={activityQuartierInfo} onChange={handleActivityQuartierChange}
                        isLoading={loadingActivityQuartiers}
                        placeholder={loadingActivityQuartiers ? "Chargement..." : "Sélectionner une localité (optionnel)"}
                        noOptionsMessage={() => "Aucune localité trouvée"} isClearable
                        className="react-select-container" classNamePrefix="react-select"
                        styles={{ control: (base) => ({ ...base, padding: '2px 0', backgroundColor: '#f8f9fa' }) }} />
                      <Form.Text className="text-muted">Si non spécifiée, la localité du compte principal sera utilisée</Form.Text>
                    </Form.Group>
                  </Col>
                  <Col md={4}>
                    <Form.Group className="mb-2">
                      <Form.Label><GeoAlt className="me-1" size={14} /> Code postal</Form.Label>
                      <Form.Control type="text" value={activityCodePostal} onChange={(e) => setActivityCodePostal(e.target.value)} placeholder="Code postal (optionnel)" />
                    </Form.Group>
                  </Col>
                </Row>
                {activityQuartierInfo && (
                  <div className="mt-2 p-2 bg-white rounded-3 border">
                    <small className="text-muted d-flex align-items-center"><GeoAlt className="me-1" size={12} />Localité sélectionnée :</small>
                    <div className="mt-1">
                      <Badge bg="primary" className="mb-1">{activityQuartierInfo.original?.nom} (Quartier)</Badge>
                      {activityQuartierInfo.parent && (
                        <div className="mt-1"><small className="text-muted">Parent :</small><Badge bg="secondary" className="ms-1">{activityQuartierInfo.parent.nom} ({getLocaliteTypeName(activityQuartierInfo.parent.type_code)})</Badge></div>
                      )}
                    </div>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowAddActivityModal(false)}>Annuler</Button>
          <Button variant="success" onClick={handleAddActivityWithLocation} disabled={addingActivity || !selectedActivityForAdd || availableActivities.length === 0}>
            {addingActivity ? <><Spinner size="sm" className="me-2" />Ajout...</> : <><PlusCircle className="me-2" />Ajouter</>}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal imprimante Bluetooth */}
      <Modal show={showDeviceModal} onHide={() => { setShowDeviceModal(false); setAvailableDevices([]); setSelectedDevice(null); }} size="md" centered>
        <Modal.Header closeButton className="bg-primary text-white"><Modal.Title><Printer className="me-2" /> Sélectionner l'imprimante</Modal.Title></Modal.Header>
        <Modal.Body>
          {scanningDevices ? <div className="text-center py-4"><Spinner animation="border" variant="primary" /><p className="mt-2 text-muted">{bluetoothStatus}</p></div> :
           availableDevices.length > 0 ? (
            <>
              <p className="text-muted mb-3">Sélectionnez votre imprimante TPE :</p>
              <ListGroup className="mb-3">
                {availableDevices.map((device, idx) => (
                  <ListGroup.Item key={idx} className={`d-flex justify-content-between align-items-center ${selectedDevice?.id === device.id ? 'active' : ''}`}
                    style={{ cursor: 'pointer' }} onClick={() => setSelectedDevice(device)}>
                    <div><strong>{device.name}</strong><small className="d-block text-muted">ID: {device.id.substring(0, 8)}...</small></div>
                    <Button variant="outline-primary" size="sm" onClick={(e) => { e.stopPropagation(); testDeviceConnection(device); }}>Tester</Button>
                  </ListGroup.Item>
                ))}
              </ListGroup>
              <div className="alert alert-info small"><InfoCircle className="me-2" /><strong>Comment identifier votre TPE ?</strong><br />• Nom contient souvent "TPE", "POS", "Printer"<br />• Utilisez "Tester" pour vérifier</div>
            </>
          ) : (
            <div className="text-center py-4"><Printer size={48} className="text-muted mb-3 opacity-50" /><p>Aucun appareil trouvé</p>
              <Button variant="primary" onClick={scanBluetoothDevices} disabled={scanningDevices}><Search className="me-2" size={14} />Rechercher</Button>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="light" onClick={() => setShowDeviceModal(false)}>Annuler</Button>
          <Button variant="success" onClick={() => { if (selectedDevice && selectedEcheance) { printOnSelectedDevice(selectedEcheance, selectedDevice); setShowDeviceModal(false); } }}
            disabled={!selectedDevice || printingBluetooth}>
            {printingBluetooth ? <><Spinner size="sm" className="me-2" />Impression...</> : <><Printer className="me-2" />Imprimer</>}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal modification taxe */}
      <Modal show={showEditTaxModal} onHide={() => setShowEditTaxModal(false)} centered>
        <Modal.Header closeButton className="bg-primary text-white"><Modal.Title><Gear className="me-2" />Modifier le montant par échéance</Modal.Title></Modal.Header>
        <Modal.Body>
          <div className="alert alert-info mb-3"><InfoCircle className="me-2" /><strong>{selectedTax?.type}</strong><br /><small>ID Taxe: {selectedTax?.taxe_id}</small></div>
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">Montant par échéance</Form.Label>
            <InputGroup><Form.Control type="number" value={editTaxAmount} onChange={e => setEditTaxAmount(e.target.value)} placeholder="Montant" /><InputGroup.Text>{defaultCurrency}</InputGroup.Text></InputGroup>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">Fréquence</Form.Label>
            <Form.Select value={editTaxFrequency} onChange={e => setEditTaxFrequency(e.target.value)}>
              <option value="monthly">Mensuelle</option><option value="quarterly">Trimestrielle</option>
              <option value="semiannual">Semestrielle</option><option value="annual">Annuelle</option>
              <option value="daily">Journalière</option><option value="one_off">Unique</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">Date échéance</Form.Label>
            <Form.Control type="date" value={editTaxStartDate} onChange={e => setEditTaxStartDate(e.target.value)} />
          </Form.Group>
          <Alert variant="warning" className="mt-2 small"><ExclamationCircle className="me-2" /><strong>Attention :</strong> Cette action recréera toutes les échéances futures.</Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditTaxModal(false)}>Annuler</Button>
          <Button variant="primary" onClick={handleUpdateTaxAmount} disabled={savingTax || !editTaxAmount}>
            {savingTax ? <><Spinner size="sm" className="me-2" />Enregistrement...</> : <><Save className="me-2" />Enregistrer</>}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal modification échéance */}
      <Modal show={showEditEcheanceModal} onHide={() => setShowEditEcheanceModal(false)} centered>
        <Modal.Header closeButton className="bg-warning text-dark"><Modal.Title><Pencil className="me-2" />Modifier l'échéance</Modal.Title></Modal.Header>
        <Modal.Body>
          <div className="alert alert-info mb-3"><InfoCircle className="me-2" /><strong>Taxe: {selectedEcheance?.taxe?.titre || 'Taxe'}</strong></div>
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">Montant</Form.Label>
            <InputGroup><Form.Control type="number" value={editEcheanceAmount} onChange={e => setEditEcheanceAmount(e.target.value)} /><InputGroup.Text>{defaultCurrency}</InputGroup.Text></InputGroup>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label className="fw-semibold">Date d'échéance</Form.Label>
            <Form.Control type="date" value={editEcheanceDate} onChange={e => setEditEcheanceDate(e.target.value)} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditEcheanceModal(false)}>Annuler</Button>
          <Button variant="warning" onClick={handleUpdateEcheance} disabled={savingEcheance || !editEcheanceAmount}>
            {savingEcheance ? <><Spinner size="sm" className="me-2" />Enregistrement...</> : <><Save className="me-2" />Enregistrer</>}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal confirmation régénération */}
      <Modal show={showRegenerateConfirm} onHide={() => setShowRegenerateConfirm(false)} centered>
        <Modal.Header closeButton className={regenerateType === 'all' ? 'bg-danger text-white' : 'bg-warning text-dark'}>
          <Modal.Title>
            {regenerateType === 'all' ? <><Trash className="me-2" /> Régénération complète</> : <><PlusCircle className="me-2" /> Régénération manquantes</>}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {regenerateType === 'all' ? (
            <>
              <div className="text-center mb-3"><ExclamationCircle size={48} className="text-danger mb-2" /><h5 className="text-danger">Attention !</h5></div>
              <p>Cette action va :</p>
              <ul>
                <li>Supprimer TOUTES les échéances NON PAYÉES</li>
                <li>Régénérer de nouvelles échéances</li>
                <li>Conserver les échéances payées</li>
              </ul>
              <div className="alert alert-warning"><strong>Cette action est irréversible !</strong></div>
            </>
          ) : (
            <>
              <div className="text-center mb-3"><InfoCircle size={48} className="text-info mb-2" /><h5>Régénération des manquantes</h5></div>
              <p>Cette action va :</p>
              <ul>
                <li>Vérifier toutes les taxes actives</li>
                <li>Générer les échéances manquantes</li>
                <li>Conserver les échéances existantes</li>
              </ul>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowRegenerateConfirm(false)}>Annuler</Button>
          <Button variant={regenerateType === 'all' ? 'danger' : 'warning'}
            onClick={regenerateType === 'all' ? regenerateAllEcheances : regenerateMissingEcheances}
            disabled={regeneratingEcheances}>
            {regeneratingEcheances ? <><Spinner size="sm" className="me-2" />Régénération...</> : <><ArrowRepeat className="me-2" />Confirmer</>}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal état échéances */}
      <Modal show={showEcheanceStatusModal} onHide={() => setShowEcheanceStatusModal(false)} centered size="lg" backdrop="static">
        <Modal.Header closeButton className="border-0" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
          <Modal.Title className="d-flex align-items-center text-white"><Activity className="me-2" size={24} /><span>État des échéances</span></Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0">
          {echeanceStatusData && (
            <>
              <div className="bg-light p-4 border-bottom">
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                  <div className="d-flex align-items-center gap-3">
                    <div className="bg-primary bg-opacity-10 rounded-circle p-3"><Building size={24} className="text-primary" /></div>
                    <div><h5 className="mb-0">{echeanceStatusData.contribuable_principal_nom}</h5><small className="text-muted">ID: {echeanceStatusData.contribuable_principal_id}</small></div>
                  </div>
                  <div className="d-flex gap-2">
                    <div className="text-center px-3 py-2 bg-white rounded shadow-sm">
                      <div className="text-muted small">Comptes vérifiés</div>
                      <div className="fw-bold fs-4">{echeanceStatusData.total_accounts}</div>
                    </div>
                    <div className="text-center px-3 py-2 bg-white rounded shadow-sm">
                      <div className="text-muted small">Total échéances</div>
                      <div className="fw-bold fs-4 text-primary">{echeanceStatusData.accounts.reduce((sum, a) => sum + a.total_echeances_existantes, 0)}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-3" style={{ maxHeight: '500px', overflowY: 'auto' }}>
                {echeanceStatusData.accounts.map((account, idx) => (
                  <Card key={idx} className="border-0 shadow-sm mb-3">
                    <Card.Header className="bg-white border-0 pt-3 pb-0">
                      <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center gap-2">
                          <div className={`rounded-circle p-2 ${account.type === 'principal' ? 'bg-primary bg-opacity-10' : 'bg-success bg-opacity-10'}`}>
                            {account.type === 'principal' ? <Building size={16} className="text-primary" /> : <Briefcase size={16} className="text-success" />}
                          </div>
                          <div><h6 className="mb-0">{account.account_nom}</h6><small className="text-muted">{account.type === 'principal' ? 'Compte principal' : 'Sous-compte'} • ID: {account.account_id}</small></div>
                        </div>
                        <Badge bg={account.type === 'principal' ? 'primary' : 'success'} className="px-3 py-2">{account.type === 'principal' ? 'Principal' : 'Secondaire'}</Badge>
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <Row className="g-3">
                        <Col md={4}><div className="bg-success bg-opacity-10 rounded p-3 text-center"><CheckCircle size={20} className="text-success mb-2" /><div className="fw-bold fs-4 text-success">{account.taxes_avec_echeances}</div><small className="text-muted">Avec échéances</small></div></Col>
                        <Col md={4}><div className="bg-danger bg-opacity-10 rounded p-3 text-center"><XCircle size={20} className="text-danger mb-2" /><div className="fw-bold fs-4 text-danger">{account.taxes_sans_echeances}</div><small className="text-muted">Sans échéances</small></div></Col>
                        <Col md={4}><div className="bg-info bg-opacity-10 rounded p-3 text-center"><Calendar size={20} className="text-info mb-2" /><div className="fw-bold fs-4 text-info">{account.total_echeances_existantes}</div><small className="text-muted">Total</small></div></Col>
                      </Row>
                    </Card.Body>
                  </Card>
                ))}
              </div>
            </>
          )}
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button variant="light" onClick={() => setShowEcheanceStatusModal(false)}>Fermer</Button>
          <Button variant="primary" onClick={() => { setShowEcheanceStatusModal(false); setRegenerateType('missing'); setShowRegenerateConfirm(true); }}>
            <ArrowRepeat className="me-2" />Régénérer les manquantes
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal modification activité */}
      <Modal show={showModifyActivityModal} onHide={() => {
        setShowModifyActivityModal(false);
        setSelectedActivityToModify(null);
        setSelectedNewActivityForModify(null);
        setModifyActivityVerification(null);
        setAvailableActivitiesForModify([]);
      }} size="lg" centered>
        <Modal.Header closeButton className="bg-warning text-dark"><Modal.Title><ArrowRepeat className="me-2" /> Modifier l'activité</Modal.Title></Modal.Header>
        <Modal.Body style={{height:'500px',overflowY:'auto'}}>
          {modifyActivityVerification && modifyActivityVerification.echeances_non_payees > 0 && (
            <Alert variant="danger" className="mb-3">
              <ExclamationCircle className="me-2" size={20} />
              <strong>Attention !</strong> {modifyActivityVerification.echeances_non_payees} échéance(s) non payée(s) seront marquées comme "deleted".
            </Alert>
          )}
          <div className="mb-3">
            <label className="form-label fw-bold">Activité actuelle</label>
            <Form.Control type="text" value={selectedActivityToModify?.currentActivityName || ''} disabled className="bg-light" />
          </div>
          <Form.Group className="mb-3">
            <Form.Label className="fw-bold">Nouvelle activité <span className="text-danger">*</span></Form.Label>
            {loadingModifyActivities ? <div className="text-center p-3 bg-light"><Spinner animation="border" size="sm" /></div> :
              <Select options={availableActivitiesForModify} value={selectedNewActivityForModify}
                onChange={async (opt) => { setSelectedNewActivityForModify(opt); if (opt && selectedActivityToModify) { await checkActivityChange(selectedActivityToModify.contribuable_id, opt.value); await fetchActivityTaxesForAdd(opt.value); } }}
                isClearable isSearchable placeholder="Sélectionner une nouvelle activité..." />
            }
          </Form.Group>
          {selectedNewActivityForModify && selectedActivityTaxes.length > 0 && (
            <div className="mb-3">
              <label className="form-label fw-bold">Taxes de la nouvelle activité</label>
              <div className="table-responsive">
                <table className="table table-sm table-bordered">
                  <thead className="table-light"><tr><th>Taxe</th><th>Montant</th><th>Fréquence</th></tr></thead>
                  <tbody>
                    {selectedActivityTaxes.map((tax, idx) => (
                      <tr key={idx}>
                        <td>{tax.taxe_name || tax.type}</td>
                        <td>{formatCurrency(tax.default_amount || tax.montant)}</td>
                        <td><Badge bg="info">
                          {tax.default_frequency === 'monthly' ? 'Mensuelle' :
                           tax.default_frequency === 'quarterly' ? 'Trimestrielle' :
                           tax.default_frequency === 'annual' ? 'Annuelle' :
                           tax.default_frequency === 'semiannual' ? 'Semestrielle' :
                           tax.default_frequency === 'daily' ? 'Journalière' : 'Mensuelle'}
                        </Badge></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <Form.Group className="mb-3">
            <Form.Check type="switch" id="regenerate-echeances-modify" label="Régénérer automatiquement les échéances"
              checked={regenerateEcheancesAfterModify} onChange={(e) => setRegenerateEcheancesAfterModify(e.target.checked)} />
          </Form.Group>
          {regenerateEcheancesAfterModify && (
            <Form.Group className="mb-3">
              <Form.Label className="fw-bold">Date de début des échéances</Form.Label>
              <Form.Control type="date" value={modifyActivityStartDate} onChange={(e) => setModifyActivityStartDate(e.target.value)} />
            </Form.Group>
          )}
          <Alert variant="info" className="mt-2">
            <InfoCircle className="me-2" /><strong>Ce que cette action va faire :</strong>
            <ul className="mb-0 mt-2">
              <li>✓ Désactiver les taxes actuelles</li>
              <li>✓ Annuler les échéances non payées</li>
              <li>✓ Mettre à jour l'activité</li>
              <li>✓ Activer les nouvelles taxes</li>
              {regenerateEcheancesAfterModify && <li>✓ Générer les nouvelles échéances</li>}
            </ul>
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModifyActivityModal(false)}>Annuler</Button>
          <Button variant="warning" onClick={handleModifyActivity} disabled={modifyingActivity || !selectedNewActivityForModify}>
            {modifyingActivity ? <><Spinner size="sm" className="me-2" />Modification...</> : <><ArrowRepeat className="me-2" />Confirmer</>}
          </Button>
        </Modal.Footer>
      </Modal>

      <style>{`
        .contribuable-name { overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width:250px; }
        .contribuable-name1 { overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width:150px; }
        .contribuable-name-wrapper { position:relative; display:inline-block; }
        .contribuable-name-wrapper:hover::after {
          content:attr(data-fullname); position:absolute; background:#333; color:white;
          padding:4px 8px; border-radius:4px; font-size:12px; white-space:nowrap;
          z-index:1000; top:100%; left:0; margin-top:4px;
        }
        .stats-card { transition:transform .3s ease; border-radius:16px; }
        .stats-card:hover { transform:translateY(-5px); }
        .icon-statistic { background:rgba(255,255,255,0.2); width:60px; height:60px; border-radius:12px; display:flex; align-items:center; justify-content:center; }
        .statistic-wave { position:absolute; bottom:0; right:0; width:100px; height:100px; background:rgba(255,255,255,0.1); border-radius:50%; transform:translate(30%,30%); }
        .progress-circle { position:relative; width:120px; height:120px; border-radius:50%; margin:0 auto; display:flex; align-items:center; justify-content:center; }
        .progress-circle-inner { width:90px; height:90px; background:white; border-radius:50%; display:flex; align-items:center; justify-content:center; box-shadow:0 4px 6px rgba(0,0,0,0.1); }
        .progress-circle-value { position:absolute; top:0; left:0; width:100%; height:100%; border-radius:50%; display:flex; align-items:center; justify-content:center; }
        .custom-tabs { border-bottom:1px solid #dee2e6; background:#f8f9fa; border-radius:12px 12px 0 0; }
        .custom-tabs .nav-link { border:none; color:#6c757d; font-weight:500; padding:.75rem 1rem; transition:all .2s; position:relative; }
        .custom-tabs .nav-link:hover { color:#0d6efd; background:rgba(13,110,253,.05); }
        .custom-tabs .nav-link.active { color:#0d6efd; background:transparent; }
        .custom-tabs .nav-link.active::after { content:''; position:absolute; bottom:-1px; left:0; right:0; height:3px; background:#0d6efd; border-radius:3px 3px 0 0; }
        .table-custom th { border-top:none; font-weight:600; text-transform:uppercase; font-size:.7rem; color:#6c757d; }
        .table-custom td { vertical-align:middle; padding:.75rem; }
        .cursor-pointer { cursor:pointer; transition:all .2s; }
        .cursor-pointer:hover { transform:translateY(-2px); box-shadow:0 4px 8px rgba(0,0,0,.1); }
        .bg-primary-subtle { background:rgba(13,110,253,.1); }
        .timeline { position:relative; padding-left:30px; }
        .timeline::before { content:''; position:absolute; left:15px; top:0; bottom:0; width:2px; background:#e9ecef; }
        .timeline-item { position:relative; margin-bottom:1.5rem; }
        .timeline-marker { position:absolute; left:-30px; top:5px; width:12px; height:12px; border-radius:50%; border:2px solid white; box-shadow:0 0 0 2px #e9ecef; }
        .timeline-content { background:white; padding:1rem; border-radius:12px; box-shadow:0 2px 4px rgba(0,0,0,.05); border:1px solid #e9ecef; }
        @media (max-width:768px) { .custom-tabs .nav-link span { display:none; } .custom-tabs .nav-link svg { margin:0; } }
      `}</style>
    </React.Fragment>
  );
}